function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.62,208.45c-20.22-69.68-76.7-124.68-149.41-143.1-19.12-4.84-39.26-7.29-59-5.2C388.74,68.66,296.06,124.3,246.71,136S135,101,73.52,172.62,39.74,410.06,175.7,442.55s204.36-47.49,265-30,166.26,10,225.15-41.66C700.74,340.27,695.16,268.93,677.62,208.45Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.62,208.45c-20.22-69.68-76.7-124.68-149.41-143.1-19.12-4.84-39.26-7.29-59-5.2C388.74,68.66,296.06,124.3,246.71,136S135,101,73.52,172.62,39.74,410.06,175.7,442.55s204.36-47.49,265-30,166.26,10,225.15-41.66C700.74,340.27,695.16,268.93,677.62,208.45Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 685.74,
    y: 399.9,
    width: 12.12,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.79,
    y: 399.9,
    width: 210.43,
    height: 1,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.43,
    y: 399.9,
    width: 15.59,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.94,
    y: 399.9,
    width: 206.96,
    height: 1,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.35,337.14c2.16.94,7.42.82,7.43.82s-1.13-3.45-1.23-3.66c-1.16-2.41-4.81-6.41-7.79-6a3.55,3.55,0,0,0-2.85,4.45C74.41,334.81,76.52,336.34,78.35,337.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.17,352.39c2.24.33,6.94-1,7.31-1.15a62.29,62.29,0,0,0,2.85,7.89q1,2.25,2.06,4.47c-.43-.63-.81-1.19-.88-1.26-1.75-2-6.33-4.91-9.09-3.74a3.56,3.56,0,0,0-1.57,5c1,1.85,3.46,2.77,5.44,3.06s6-.79,7.1-1.09l.84,1.7c1.36,2.71,2.73,5.41,4,8.1.44.94.85,1.89,1.25,2.84-.38-.56-.7-1-.76-1.09-1.75-2-6.33-4.91-9.09-3.74a3.56,3.56,0,0,0-1.58,5.05c1,1.85,3.47,2.77,5.45,3.06s5.64-.69,6.91-1c.38,1,.78,2,1.11,2.94.21.67.46,1.3.63,2s.38,1.34.56,2c.31,1.28.63,2.6.9,3.86.2.87.36,1.71.54,2.55-.44-.95-1.32-2.79-1.41-2.93-1.43-2.27-5.52-5.82-8.43-5.07A3.54,3.54,0,0,0,92,390.57c.72,2,3,3.27,4.91,3.86,2.11.64,6.77.05,7.36,0,.27,1.4.53,2.76.76,4,.12.68.22,1.32.33,2h1.85c-.14-.74-.28-1.49-.44-2.29-.27-1.41-.6-2.92-1-4.47a37.6,37.6,0,0,0,4.11-1.92c1.53,1.66,5.47,3.6,6,3.85-.53,1.32-1.06,2.59-1.59,3.79-.15.36-.31.7-.46,1h2l.15-.35c.55-1.33,1.11-2.77,1.67-4.25.57.12,5.18,1.05,7.34.57,2-.44,4.31-1.55,5.19-3.48a3.54,3.54,0,0,0-2-4.9c-2.85-1-7.19,2.27-8.78,4.43-.09.12-1,1.62-1.49,2.57.23-.61.46-1.19.68-1.82.46-1.24.87-2.49,1.32-3.83.2-.65.4-1.32.6-2s.35-1.39.53-2.08c.39-1.63.7-3.29,1-5,1.09.39,5,1.74,7,1.6s4.5-.88,5.66-2.65a3.55,3.55,0,0,0-1.2-5.15c-2.66-1.38-7.44,1.16-9.34,3.05-.12.12-1.33,1.63-2,2.47.16-1,.32-2,.45-3.06.37-3,.65-6,1-9,.09-.92.19-1.84.28-2.76.39.14,4.95,1.84,7.2,1.69,2-.14,4.5-.88,5.66-2.65a3.56,3.56,0,0,0-1.2-5.15c-2.66-1.38-7.44,1.16-9.34,3.05-.15.14-1.88,2.32-2.3,2.89.21-2,.45-4,.76-6a61.87,61.87,0,0,1,1.73-7.93c.17.07,4.93,1.87,7.23,1.71,2-.15,4.5-.88,5.66-2.65a3.55,3.55,0,0,0-1.19-5.15c-2.67-1.38-7.45,1.16-9.35,3.05-.15.15-2,2.49-2.33,2.94,0-.15.08-.32.12-.47a46.12,46.12,0,0,1,3.14-7.49c.68-1.34,1.41-2.58,2.15-3.76.85.42,4.76,2.32,6.85,2.4s4.57-.37,5.91-2a3.54,3.54,0,0,0-.62-5.24c-2.5-1.66-7.53.33-9.62,2-.12.09-1.17,1.14-1.93,1.92.34-.53.68-1.09,1-1.59,1.26-1.89,2.52-3.54,3.66-5,.65-.82,1.25-1.55,1.83-2.23,1,0,5.3-.15,7.15-1s3.88-2.43,4.32-4.51a3.55,3.55,0,0,0-3-4.37c-3-.32-6.52,3.77-7.61,6.22-.1.21-1.19,3.68-1.14,3.68h.07c-.57.64-1.17,1.34-1.8,2.11-1.17,1.43-2.48,3.06-3.78,4.93a63.52,63.52,0,0,0-3.91,6.24,45.72,45.72,0,0,0-3.34,7.52l0,.1c0-.88,0-3.34,0-3.53-.34-2.66-2.57-7.59-5.52-8.14a3.56,3.56,0,0,0-4.09,3.34c-.18,2.12,1.35,4.23,2.85,5.56,1.68,1.51,6.35,3,6.72,3.08a63.38,63.38,0,0,0-2,8.15c-.29,1.6-.52,3.23-.74,4.86,0-.76,0-1.44,0-1.53-.35-2.66-2.57-7.59-5.52-8.14a3.55,3.55,0,0,0-4.1,3.34c-.17,2.11,1.36,4.22,2.85,5.56s5.47,2.67,6.52,3c-.07.63-.16,1.25-.23,1.88-.36,3-.71,6-1.14,8.95-.15,1-.33,2.05-.52,3.07,0-.68,0-1.24,0-1.33-.35-2.66-2.58-7.59-5.53-8.14a3.56,3.56,0,0,0-4.09,3.34c-.17,2.12,1.36,4.23,2.85,5.56s5.09,2.55,6.34,3c-.22,1-.44,2.07-.7,3.06-.19.68-.33,1.34-.56,2s-.43,1.33-.64,2c-.45,1.24-.9,2.52-1.37,3.71-.33.84-.65,1.63-1,2.43.16-1,.44-3,.44-3.23a13.66,13.66,0,0,0-1.85-6.7,4.14,4.14,0,0,0,0-.79,3.55,3.55,0,0,0-4.35-3c-2.9.77-4.73,5.86-4.87,8.54,0,.16.09,1.88.18,3-.15-.63-.28-1.24-.44-1.89-.31-1.28-.65-2.55-1-3.92l-.6-2c-.19-.67-.47-1.35-.7-2-.57-1.57-1.23-3.13-1.93-4.69,1.13-.27,5.1-1.28,6.69-2.5s3.27-3.22,3.26-5.33a3.56,3.56,0,0,0-3.84-3.64c-3,.32-5.57,5.08-6.11,7.7,0,.16-.21,2.09-.29,3.15-.42-.93-.84-1.87-1.31-2.8-1.33-2.68-2.76-5.36-4.18-8-.44-.82-.86-1.64-1.29-2.47.4-.09,5.15-1.19,6.94-2.56,1.59-1.22,3.27-3.21,3.25-5.33a3.54,3.54,0,0,0-3.83-3.63c-3,.32-5.57,5.07-6.11,7.7,0,.19-.29,3-.32,3.67-.94-1.8-1.86-3.62-2.7-5.44a64.64,64.64,0,0,1-2.93-7.56c.19,0,5.15-1.17,7-2.57,1.59-1.22,3.27-3.21,3.26-5.33a3.56,3.56,0,0,0-3.84-3.64c-3,.33-5.57,5.08-6.11,7.7,0,.21-.31,3.19-.32,3.73l-.16-.45a45.41,45.41,0,0,1-1.51-8c-.17-1.49-.25-2.92-.29-4.32.94-.12,5.26-.69,7-1.77s3.61-2.83,3.83-4.94a3.57,3.57,0,0,0-3.42-4c-3,0-6.09,4.44-6.92,7,0,.13-.34,1.59-.55,2.66,0-.63,0-1.28,0-1.89,0-2.26.15-4.34.29-6.18.09-1.05.19-2,.3-2.87.87-.6,4.34-3.05,5.4-4.8s1.9-4.17,1.12-6.14a3.55,3.55,0,0,0-4.89-2c-2.66,1.38-3.37,6.74-2.92,9.39,0,.22,1,3.73,1.09,3.7l0,0c-.12.85-.23,1.76-.34,2.75-.18,1.84-.37,3.92-.43,6.2a61.94,61.94,0,0,0,.18,7.36,46.41,46.41,0,0,0,1.36,8.11l0,.1c-.47-.74-1.86-2.77-2-2.92-1.76-2-6.33-4.91-9.1-3.73a3.54,3.54,0,0,0-1.57,5C75.75,351.19,78.19,352.1,80.17,352.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.62,338.3s1-3.5,1-3.73c.37-2.66-.47-8-3.17-9.31a3.56,3.56,0,0,0-4.84,2.14c-.72,2,.2,4.44,1.29,6.12C127.16,335.49,131.62,338.29,131.62,338.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.25,306.93V277.05h10.81v2.17h-8v11.22h6.5v2.07h-6.5v12.32h8.05v2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,306.93V277.05h6.76a9,9,0,0,1,4.4.9,5.19,5.19,0,0,1,2.31,2.62,10.68,10.68,0,0,1,.7,4.08,12.66,12.66,0,0,1-.37,3.13,5.94,5.94,0,0,1-1.25,2.51,4.32,4.32,0,0,1-2.51,1.37l4.57,15.27h-2.73l-4.39-14.68h-4.68v14.68Zm2.81-16.75h3.8a5.61,5.61,0,0,0,2.91-.63,3.45,3.45,0,0,0,1.48-1.84,9.18,9.18,0,0,0,.44-3.06,7.2,7.2,0,0,0-1-4.13c-.64-.91-1.9-1.37-3.8-1.37h-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.86,306.93V277.05h6.75a9.06,9.06,0,0,1,4.41.9,5.19,5.19,0,0,1,2.31,2.62,10.68,10.68,0,0,1,.7,4.08,12.66,12.66,0,0,1-.37,3.13,5.94,5.94,0,0,1-1.25,2.51,4.32,4.32,0,0,1-2.51,1.37l4.57,15.27h-2.73l-4.39-14.68h-4.68v14.68Zm2.81-16.75h3.8a5.61,5.61,0,0,0,2.91-.63,3.45,3.45,0,0,0,1.48-1.84,9.18,9.18,0,0,0,.44-3.06,7.2,7.2,0,0,0-1-4.13c-.64-.91-1.91-1.37-3.8-1.37h-3.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8,307.3a8.07,8.07,0,0,1-4.63-1.16,6.14,6.14,0,0,1-2.36-3.25,15.2,15.2,0,0,1-.68-4.78V285.72a14.06,14.06,0,0,1,.72-4.74,6,6,0,0,1,2.39-3.12,10,10,0,0,1,9.15,0,5.94,5.94,0,0,1,2.38,3.12,14.34,14.34,0,0,1,.7,4.74v12.43a15,15,0,0,1-.68,4.76,6.2,6.2,0,0,1-2.34,3.23A8.07,8.07,0,0,1,390.8,307.3Zm0-2.25a4.86,4.86,0,0,0,3-.79,4.05,4.05,0,0,0,1.43-2.22,12.91,12.91,0,0,0,.38-3.3V285.2a12.74,12.74,0,0,0-.38-3.28,3.83,3.83,0,0,0-1.43-2.16,5.07,5.07,0,0,0-3-.76,5.14,5.14,0,0,0-3,.76,3.79,3.79,0,0,0-1.44,2.16,12.74,12.74,0,0,0-.38,3.28v13.54a12.91,12.91,0,0,0,.38,3.3,4,4,0,0,0,1.44,2.22A4.93,4.93,0,0,0,390.8,305.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.12,306.93V277.05h6.75a9.06,9.06,0,0,1,4.41.9,5.19,5.19,0,0,1,2.31,2.62,10.88,10.88,0,0,1,.7,4.08,12.66,12.66,0,0,1-.37,3.13,6.06,6.06,0,0,1-1.25,2.51,4.35,4.35,0,0,1-2.51,1.37l4.57,15.27H415l-4.39-14.68h-4.68v14.68Zm2.81-16.75h3.8a5.61,5.61,0,0,0,2.91-.63,3.45,3.45,0,0,0,1.48-1.84,9.18,9.18,0,0,0,.44-3.06,7.2,7.2,0,0,0-1-4.13c-.64-.91-1.91-1.37-3.8-1.37h-3.87Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Number--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.24,256.78V237H300.13V225.2l21-49.11h16V226h8.26v11h-8.26v19.82ZM311.69,226h12.55V190.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,257.28H323.74V237.46H299.63l0-12.45,21.15-49.42h16.87V225.5H346v12h-8.27Zm-12.95-1h11.95V236.46H345v-10h-8.27V176.59H321.48l-20.85,48.72v11.15h24.11Zm0-29.78H311l13.76-38.44Zm-12.34-1h11.34V193.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,258A21.23,21.23,0,0,1,362,255a18.49,18.49,0,0,1-7-8.27,29.73,29.73,0,0,1-2.34-12.15V198.81A31.74,31.74,0,0,1,355,186.4a17.89,17.89,0,0,1,6.87-8.32q4.64-3,11.91-3t11.9,3a17.89,17.89,0,0,1,6.87,8.32,31.74,31.74,0,0,1,2.24,12.41v35.76a29.73,29.73,0,0,1-2.34,12.15,18.49,18.49,0,0,1-7,8.27A21.22,21.22,0,0,1,373.75,258Zm0-11.86a5.5,5.5,0,0,0,4.58-1.89,10.32,10.32,0,0,0,2-4.58,29.18,29.18,0,0,0,.5-5.28V199a34,34,0,0,0-.45-5.52,10,10,0,0,0-1.94-4.64,6.75,6.75,0,0,0-9.37,0,10,10,0,0,0-1.94,4.64,34,34,0,0,0-.45,5.52v35.37a26.1,26.1,0,0,0,.55,5.28,10.73,10.73,0,0,0,2,4.58A5.38,5.38,0,0,0,373.75,246.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,258.48a21.83,21.83,0,0,1-12-3.07,19,19,0,0,1-7.16-8.49,30.33,30.33,0,0,1-2.38-12.35V198.81a32.31,32.31,0,0,1,2.28-12.6,18.48,18.48,0,0,1,7.06-8.55c3.16-2,7.25-3.06,12.18-3.06s9,1,12.17,3.07a18.35,18.35,0,0,1,7.06,8.54,32.31,32.31,0,0,1,2.28,12.6v35.76a30.37,30.37,0,0,1-2.38,12.35,19,19,0,0,1-7.16,8.49A21.8,21.8,0,0,1,373.75,258.48Zm0-82.88c-4.73,0-8.65,1-11.64,2.9a17.51,17.51,0,0,0-6.68,8.1,31.46,31.46,0,0,0-2.2,12.21v35.76a29.28,29.28,0,0,0,2.3,12,18.09,18.09,0,0,0,6.78,8,23.92,23.92,0,0,0,22.87,0,18.18,18.18,0,0,0,6.79-8,29.45,29.45,0,0,0,2.29-12V198.81a31.46,31.46,0,0,0-2.2-12.21,17.45,17.45,0,0,0-6.68-8.1C382.39,176.58,378.47,175.6,373.75,175.6Zm0,71a5.86,5.86,0,0,1-4.88-2.08,11.29,11.29,0,0,1-2.14-4.79,27.09,27.09,0,0,1-.56-5.38V199a35.19,35.19,0,0,1,.46-5.61,10.52,10.52,0,0,1,2-4.86,7.23,7.23,0,0,1,10.15,0,10.51,10.51,0,0,1,2,4.87,33.85,33.85,0,0,1,.46,5.6v35.37a29.36,29.36,0,0,1-.51,5.37,10.76,10.76,0,0,1-2.09,4.8A6,6,0,0,1,373.75,246.62Zm0-59.17a5.09,5.09,0,0,0-4.29,1.7,9.41,9.41,0,0,0-1.84,4.41,33,33,0,0,0-.45,5.44v35.37a25.76,25.76,0,0,0,.54,5.18,10.28,10.28,0,0,0,2,4.37,4.83,4.83,0,0,0,4.09,1.7,5,5,0,0,0,4.19-1.7,9.89,9.89,0,0,0,1.89-4.36,29.17,29.17,0,0,0,.49-5.19V199a34.12,34.12,0,0,0-.44-5.44,9.52,9.52,0,0,0-1.85-4.41A5.08,5.08,0,0,0,373.75,187.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,256.78V237H403.53V225.2l21-49.11h16V226h8.26v11h-8.26v19.82ZM415.09,226h12.55V190.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09,257.28H427.14V237.46H403l0-12.45,21.15-49.42h16.87V225.5h8.26v12h-8.26Zm-12.95-1h11.95V236.46h8.26v-10h-8.26V176.59H424.88L404,225.31v11.15h24.11Zm0-29.78H414.38l13.76-38.44Zm-12.34-1h11.34V193.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.24,249.85V230H300.13V218.28l21-49.12h16v49.91h8.26v11h-8.26v19.82Zm-12.55-30.78h12.55V184Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,250.35H323.74V230.53H299.63l0-12.45,21.15-49.41h16.87v49.9H346v12h-8.27Zm-12.95-1h11.95V229.53H345v-10h-8.27v-49.9H321.48l-20.85,48.71v11.15h24.11Zm0-29.78H311l13.76-38.44Zm-12.34-1h11.34V186.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,251.05a21.23,21.23,0,0,1-11.71-3,18.49,18.49,0,0,1-7-8.27,29.73,29.73,0,0,1-2.34-12.15V191.88a31.66,31.66,0,0,1,2.24-12.4,17.79,17.79,0,0,1,6.87-8.32q4.64-3,11.91-3t11.9,3a17.79,17.79,0,0,1,6.87,8.32,31.66,31.66,0,0,1,2.24,12.4v35.76a29.73,29.73,0,0,1-2.34,12.15,18.49,18.49,0,0,1-7,8.27A21.22,21.22,0,0,1,373.75,251.05Zm0-11.86a5.5,5.5,0,0,0,4.58-1.89,10.32,10.32,0,0,0,2-4.58,29.1,29.1,0,0,0,.5-5.28V192.08a34.1,34.1,0,0,0-.45-5.53,10,10,0,0,0-1.94-4.63,6.73,6.73,0,0,0-9.37,0,10,10,0,0,0-1.94,4.63,34.1,34.1,0,0,0-.45,5.53v35.36a26,26,0,0,0,.55,5.28,10.73,10.73,0,0,0,2,4.58A5.38,5.38,0,0,0,373.75,239.19Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,251.55a21.75,21.75,0,0,1-12-3.07,19.08,19.08,0,0,1-7.16-8.48,30.42,30.42,0,0,1-2.38-12.36V191.88a32.34,32.34,0,0,1,2.28-12.6,18.41,18.41,0,0,1,7.06-8.54c3.16-2,7.25-3.07,12.18-3.07s9,1,12.17,3.07a18.4,18.4,0,0,1,7.06,8.54,32.34,32.34,0,0,1,2.28,12.6v35.76A30.42,30.42,0,0,1,392.88,240a19.08,19.08,0,0,1-7.16,8.48A21.71,21.71,0,0,1,373.75,251.55Zm0-82.88c-4.73,0-8.65,1-11.64,2.91a17.48,17.48,0,0,0-6.68,8.09,31.46,31.46,0,0,0-2.2,12.21v35.76a29.28,29.28,0,0,0,2.3,12,18.09,18.09,0,0,0,6.78,8,23.92,23.92,0,0,0,22.87,0,18.18,18.18,0,0,0,6.79-8,29.45,29.45,0,0,0,2.29-12V191.88a31.46,31.46,0,0,0-2.2-12.21,17.42,17.42,0,0,0-6.68-8.09C382.39,169.65,378.47,168.67,373.75,168.67Zm0,71a5.86,5.86,0,0,1-4.88-2.08,11.29,11.29,0,0,1-2.14-4.79,26.94,26.94,0,0,1-.56-5.38V192.08a35,35,0,0,1,.46-5.61,10.47,10.47,0,0,1,2-4.86,7.21,7.21,0,0,1,10.15,0,10.47,10.47,0,0,1,2,4.86,33.88,33.88,0,0,1,.46,5.61v35.36a29.28,29.28,0,0,1-.51,5.37,10.76,10.76,0,0,1-2.09,4.8A6,6,0,0,1,373.75,239.69Zm0-59.17a5.07,5.07,0,0,0-4.29,1.71,9.42,9.42,0,0,0-1.84,4.4,33,33,0,0,0-.45,5.45v35.36a25.76,25.76,0,0,0,.54,5.18,10.18,10.18,0,0,0,2,4.37,4.83,4.83,0,0,0,4.09,1.7,5,5,0,0,0,4.19-1.7,9.89,9.89,0,0,0,1.89-4.36,29.09,29.09,0,0,0,.49-5.19V192.08a34.15,34.15,0,0,0-.44-5.45,9.53,9.53,0,0,0-1.85-4.4A5.06,5.06,0,0,0,373.75,180.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,249.85V230H403.53V218.28l21-49.12h16v49.91h8.26v11h-8.26v19.82Zm-12.55-30.78h12.55V184Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.09,250.35H427.14V230.53H403l0-12.45,21.15-49.41h16.87v49.9h8.26v12h-8.26Zm-12.95-1h11.95V229.53h8.26v-10h-8.26v-49.9H424.88L404,218.38v11.15h24.11Zm0-29.78H414.38l13.76-38.44Zm-12.34-1h11.34V186.89Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.42,
    y: 155.97,
    width: 1,
    height: 22.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.42,
    y: 166.96,
    width: 22.99,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.11,
    y: 354.62,
    width: 1,
    height: 22.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.11,
    y: 365.61,
    width: 22.99,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.11,
    y: 355.52,
    width: 1,
    height: 22.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.12,
    y: 366.52,
    width: 22.99,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.84,
    y: 109.01,
    width: 1,
    height: 22.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.84,
    y: 120,
    width: 22.99,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.66,
    y: 109.01,
    width: 1,
    height: 22.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.67,
    y: 120,
    width: 22.99,
    height: 1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.87,97.53a6.82,6.82,0,1,1,6.82-6.82A6.83,6.83,0,0,1,523.87,97.53Zm0-12.64a5.82,5.82,0,1,0,5.82,5.82A5.83,5.83,0,0,0,523.87,84.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.67,129.13a6.82,6.82,0,1,1,6.82-6.82A6.83,6.83,0,0,1,674.67,129.13Zm0-12.64a5.82,5.82,0,1,0,5.82,5.82A5.83,5.83,0,0,0,674.67,116.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86,247.42a6.82,6.82,0,1,1,6.82-6.82A6.83,6.83,0,0,1,95.86,247.42Zm0-12.64a5.82,5.82,0,1,0,5.82,5.82A5.83,5.83,0,0,0,95.86,234.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,111.07a6.82,6.82,0,1,1,6.82-6.82A6.83,6.83,0,0,1,199.71,111.07Zm0-12.64a5.82,5.82,0,1,0,5.82,5.82A5.83,5.83,0,0,0,199.71,98.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,374.74a6.82,6.82,0,1,1,6.83-6.82A6.83,6.83,0,0,1,160,374.74Zm0-12.64a5.82,5.82,0,1,0,5.83,5.82A5.83,5.83,0,0,0,160,362.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.15,258.26a6.83,6.83,0,1,1,6.82-6.82A6.83,6.83,0,0,1,670.15,258.26Zm0-12.65a5.83,5.83,0,1,0,5.82,5.83A5.83,5.83,0,0,0,670.15,245.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "473 357.27 510.08 334.92 510.08 156.15 473 133.8 473 357.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.5,358.15V132.92l38.08,23V335.21l-.24.14Zm1-223.46V356.38l36.08-21.74V156.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.59,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.11,299.25h-3.37a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,480.11,299.25Zm-3.37-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.37a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.46,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,300h-3.37a1.49,1.49,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48H478a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,478,300Zm-3.37-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83H478a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.05,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.58,299.25H485.2a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.49,1.49,0,0,1,1.48-1.48h3.38a1.49,1.49,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,488.58,299.25Zm-3.38-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.38a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.92,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.45,300h-3.37a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v13.85A1.49,1.49,0,0,1,486.45,300Zm-3.37-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.37a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.51,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,299.25h-3.37a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.48,1.48,0,0,1,1.48-1.48H497a1.48,1.48,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,497,299.25Zm-3.37-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84H497a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.38,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.91,300h-3.37a1.48,1.48,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v13.85A1.48,1.48,0,0,1,494.91,300Zm-3.37-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.37a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.97,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.5,299.25h-3.37a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,505.5,299.25Zm-3.37-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.37a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.84,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.37,300H500a1.48,1.48,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v13.85A1.48,1.48,0,0,1,503.37,300ZM500,283.81a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.37a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.44,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514,299.25h-3.37a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.49,1.49,0,0,1,1.48-1.48H514a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,514,299.25Zm-3.37-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84H514a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.31,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.84,300h-3.38a1.49,1.49,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.38a1.48,1.48,0,0,1,1.48,1.48v13.85A1.49,1.49,0,0,1,511.84,300Zm-3.38-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.38a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.9,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.43,299.25h-3.38a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.49,1.49,0,0,1,1.48-1.48h3.38a1.49,1.49,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,522.43,299.25Zm-3.38-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.38a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.77,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.3,300h-3.37a1.48,1.48,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v13.85A1.48,1.48,0,0,1,520.3,300Zm-3.37-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.37a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.36,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.89,299.25h-3.37a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,530.89,299.25Zm-3.37-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.37a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.23,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.76,300h-3.37a1.48,1.48,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v13.85A1.48,1.48,0,0,1,528.76,300Zm-3.37-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.37a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.82,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.35,299.25H536a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.48,1.48,0,0,1,1.48-1.48h3.37a1.48,1.48,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,539.35,299.25ZM536,284.53a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.37a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 532.7,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.22,300h-3.37a1.49,1.49,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.37a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,537.22,300Zm-3.37-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.37a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543.29,
    y: 284.21,
    width: 5.68,
    height: 14.72,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.82,299.25h-3.38a1.49,1.49,0,0,1-1.48-1.49v-12.4a1.49,1.49,0,0,1,1.48-1.48h3.38a1.49,1.49,0,0,1,1.48,1.48v12.4A1.49,1.49,0,0,1,547.82,299.25Zm-3.38-14.72a.83.83,0,0,0-.83.83v12.4a.84.84,0,0,0,.83.84h3.38a.84.84,0,0,0,.83-.84v-12.4a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.16,
    y: 283.48,
    width: 5.68,
    height: 16.16,
    rx: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.69,300h-3.38a1.49,1.49,0,0,1-1.48-1.48V284.64a1.48,1.48,0,0,1,1.48-1.48h3.38a1.48,1.48,0,0,1,1.48,1.48v13.85A1.49,1.49,0,0,1,545.69,300Zm-3.38-16.16a.83.83,0,0,0-.83.83v13.85a.83.83,0,0,0,.83.83h3.38a.83.83,0,0,0,.83-.83V284.64a.83.83,0,0,0-.83-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661,308.53h16.39a4.36,4.36,0,0,1,4.36,4.36v5.68a0,0,0,0,1,0,0h-25.1a0,0,0,0,1,0,0v-5.68a4.36,4.36,0,0,1,4.36-4.36Z",
    transform: "translate(204.23 887.97) rotate(-76.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.46,327.55l-6-1.49a4.84,4.84,0,0,1-3.55-5.88l3.93-15.91a4.87,4.87,0,0,1,5.88-3.55l6,1.49Zm-.91-26a3.84,3.84,0,0,0-3.74,2.93l-3.93,15.91a3.85,3.85,0,0,0,2.82,4.67l5,1.24,5.78-23.39-5-1.25A4.22,4.22,0,0,0,670.55,301.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "708.45 315.84 707.12 321.24 677.19 313.56 680.62 299.69 708.45 315.84",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.48,321.85l-30.9-7.93,3.71-15L709,315.6Zm-29.69-8.65,29,7.43,1.13-4.54-26.94-15.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "705.26 328.74 706.6 323.34 676.54 316.19 673.11 330.06 705.26 328.74",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.46,330.59l3.71-15,31,7.38-1.54,6.25Zm4.44-13.8-3.15,12.74,31.12-1.27,1.12-4.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.33,
    y: 297.5,
    width: 5.84,
    height: 35.08,
    transform: "translate(95.35 -152.86) rotate(13.89)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.24,333.37l-6.64-1.64,8.66-35,6.64,1.64ZM668.82,331l4.69,1.16,8.18-33.08-4.7-1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.42,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,481.42,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.42,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,481.42,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.88,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,478.88,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.88,241.37h-4a1.73,1.73,0,0,1-1.75-1.71v-16a1.73,1.73,0,0,1,1.75-1.71h4a1.73,1.73,0,0,1,1.75,1.71v16A1.73,1.73,0,0,1,478.88,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.54,240.16h-4a1.36,1.36,0,0,1-1.39-1.33V224.52a1.36,1.36,0,0,1,1.39-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,491.54,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.54,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.75,1.71v14.31A1.73,1.73,0,0,1,491.54,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,489,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16A1.73,1.73,0,0,1,485,222h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,489,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.65,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.39,1.34v14.31A1.36,1.36,0,0,1,501.65,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.65,240.54h-4a1.73,1.73,0,0,1-1.75-1.71V224.52a1.73,1.73,0,0,1,1.75-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,501.65,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.11,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,499.11,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.11,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,499.11,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.77,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,511.77,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.77,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,511.77,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.23,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,509.23,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.23,241.37h-4a1.72,1.72,0,0,1-1.75-1.71v-16a1.72,1.72,0,0,1,1.75-1.71h4a1.73,1.73,0,0,1,1.75,1.71v16A1.73,1.73,0,0,1,509.23,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.89,240.16h-4a1.36,1.36,0,0,1-1.39-1.33V224.52a1.36,1.36,0,0,1,1.39-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,521.89,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.89,240.54h-4a1.74,1.74,0,0,1-1.75-1.71V224.52a1.74,1.74,0,0,1,1.75-1.71h4a1.73,1.73,0,0,1,1.75,1.71v14.31A1.73,1.73,0,0,1,521.89,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.34,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,519.34,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.34,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,519.34,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,532,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,532,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.46,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,529.46,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.46,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.72,1.72,0,0,1,1.75,1.71v16A1.72,1.72,0,0,1,529.46,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.12,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,542.12,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.12,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,542.12,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.57,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.39,1.34v16A1.36,1.36,0,0,1,539.57,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.58,241.37h-4a1.73,1.73,0,0,1-1.75-1.71v-16a1.73,1.73,0,0,1,1.75-1.71h4a1.73,1.73,0,0,1,1.75,1.71v16A1.73,1.73,0,0,1,539.58,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.24,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,552.24,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.24,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.75,1.71v14.31A1.73,1.73,0,0,1,552.24,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.69,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,549.69,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.69,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,549.69,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559,240.34a2.09,2.09,0,0,0-.83-.17s-.21,0-.38-.11a1.6,1.6,0,0,1-.44-.29,1.29,1.29,0,0,1-.4-.94V224.52a1.29,1.29,0,0,1,.4-.94,1.4,1.4,0,0,1,.44-.29,1.35,1.35,0,0,1,.7-.09,18.93,18.93,0,0,1,7,1.46c1.27.55,1.94,1.61,1.55,2.25l-7.14,12.41C559.53,239.93,559.11,240.41,559,240.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559,240.73a.33.33,0,0,1-.19-.06,1.73,1.73,0,0,0-.66-.12h-.33v-.08l-.18-.06a1.88,1.88,0,0,1-.56-.37,1.68,1.68,0,0,1-.52-1.21V224.52a1.68,1.68,0,0,1,.52-1.21,1.88,1.88,0,0,1,.56-.37,1.81,1.81,0,0,1,.86-.12,19.62,19.62,0,0,1,7.15,1.49,3.15,3.15,0,0,1,1.81,1.75,1.23,1.23,0,0,1-.09,1.05l-7.13,12.39C559.61,240.52,559.23,240.73,559,240.73Zm-.77-.93a2.55,2.55,0,0,1,.74.13,4.16,4.16,0,0,0,.61-.81l7.14-12.39a.53.53,0,0,0,0-.45,2.48,2.48,0,0,0-1.4-1.28,18.72,18.72,0,0,0-6.87-1.43,1.15,1.15,0,0,0-.56.07,1.06,1.06,0,0,0-.31.21.93.93,0,0,0-.3.67v14.31a.93.93,0,0,0,.3.67,1.06,1.06,0,0,0,.31.21l.24.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.35,241a.32.32,0,0,0-.14,0,3.52,3.52,0,0,0-.42,0h-2a1.36,1.36,0,0,1-1.39-1.34v-16a1.36,1.36,0,0,1,1.39-1.34h2c.21,0,1,0,1.6.05a16.8,16.8,0,0,1,1.86.21c1.43.2,2.36,1.16,2.14,1.84l-4.49,15.33A3.39,3.39,0,0,1,558.35,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.12,241.41l-.06,0h-2.28a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h2c.23,0,1.07,0,1.62.05a14.91,14.91,0,0,1,1.9.21,3.23,3.23,0,0,1,2.27,1.28,1.25,1.25,0,0,1,.17,1l-4.49,15.33c-.46,1.46-.68,1.49-.86,1.51h-.06l-.12,0Zm-.19-.79h.25a7.07,7.07,0,0,0,.36-1L563,224.34a.49.49,0,0,0-.09-.42,2.47,2.47,0,0,0-1.74-.94,14.23,14.23,0,0,0-1.83-.2c-.62,0-1.39-.06-1.56-.05h-2a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.33,241.91a2.36,2.36,0,0,0-.34-.76c-.09-.13.26-.63.79-1.13l10.56-9.67c.53-.51,1.73-.11,2.53,1a19.37,19.37,0,0,1,3,6.54c.34,1.34-.18,2.52-.89,2.58l-14.23,1.56C561,242.11,560.37,242,560.33,241.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.14,242.45c-1,0-1.13-.31-1.17-.43v0a1.87,1.87,0,0,0-.28-.63c-.09-.12-.34-.49.84-1.61l10.56-9.67a1.27,1.27,0,0,1,1-.31,3.08,3.08,0,0,1,2.07,1.39,19.51,19.51,0,0,1,3,6.66,3.11,3.11,0,0,1-.32,2.48,1.27,1.27,0,0,1-.9.56l-14.22,1.56Zm-.49-.79a4,4,0,0,0,1,0l14.22-1.56a.5.5,0,0,0,.36-.25,2.32,2.32,0,0,0,.2-1.86,18.7,18.7,0,0,0-2.9-6.41,2.33,2.33,0,0,0-1.53-1.08.53.53,0,0,0-.43.12L561,240.29a4.81,4.81,0,0,0-.65.77A3.24,3.24,0,0,1,560.65,241.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.41,241.8a1.58,1.58,0,0,0-.34-.43c-.07-.07.19-.6.6-1.23l9-13.24c.39-.61,1.7-.48,2.77.48a20.07,20.07,0,0,1,4.59,5.88c.67,1.28.47,2.59-.22,2.82l-15,5.43A3.44,3.44,0,0,1,559.41,241.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.47,242.19c-.27,0-.33-.1-.39-.2v0a1.11,1.11,0,0,0-.25-.32c-.17-.17-.35-.35.53-1.72l9-13.24a1.21,1.21,0,0,1,.89-.52,3.25,3.25,0,0,1,2.44.93,20.36,20.36,0,0,1,4.68,6,3.32,3.32,0,0,1,.3,2.6,1.3,1.3,0,0,1-.74.75l-15,5.42A4.92,4.92,0,0,1,559.47,242.19Zm0-.95.14.19a9.87,9.87,0,0,0,1-.28l15-5.42a.54.54,0,0,0,.29-.32,2.56,2.56,0,0,0-.27-2,19.48,19.48,0,0,0-4.51-5.77,2.46,2.46,0,0,0-1.84-.74.47.47,0,0,0-.36.18l-9,13.25A7,7,0,0,0,559.48,241.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.4,250v-4a1.36,1.36,0,0,1,1.34-1.38h14.31a1.35,1.35,0,0,1,1.33,1.38v4a1.36,1.36,0,0,1-1.33,1.38H561.74A1.36,1.36,0,0,1,560.4,250Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.05,251.75H561.74A1.73,1.73,0,0,1,560,250v-4a1.74,1.74,0,0,1,1.71-1.76h14.31a1.74,1.74,0,0,1,1.71,1.76v4A1.73,1.73,0,0,1,576.05,251.75ZM561.74,245a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h14.31a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.57,247.45v-4a1.38,1.38,0,0,1,.39-1,8,8,0,0,1,.93-.11l16-.6a1.11,1.11,0,0,1,1,.7,1.4,1.4,0,0,1,.4,1v4a1.36,1.36,0,0,1-1.34,1.39h-16A1.36,1.36,0,0,1,559.57,247.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.88,249.21h-16a1.74,1.74,0,0,1-1.71-1.76v-4a1.76,1.76,0,0,1,.51-1.24l.08-.08.11,0a6.24,6.24,0,0,1,1-.11l16-.61a1.44,1.44,0,0,1,1.31.9,1.66,1.66,0,0,1,.44,1.16v4A1.74,1.74,0,0,1,576.88,249.21Zm-16.73-6.41a1,1,0,0,0-.21.62v4a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1v-4a1.07,1.07,0,0,0-.29-.73c-.24-.4-.45-.58-.68-.58l-16,.61A5.74,5.74,0,0,0,560.15,242.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.79,248.67H554a2.17,2.17,0,0,0-2.06,1.49l-1.39,4.26h37.69l-1.4-4.26A2.16,2.16,0,0,0,584.79,248.67Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.94,254.92H549.87l1.61-4.91a2.66,2.66,0,0,1,2.53-1.84h30.78a2.67,2.67,0,0,1,2.54,1.84Zm-37.69-1h36.31l-1.18-3.6a1.67,1.67,0,0,0-1.59-1.15H554a1.65,1.65,0,0,0-1.58,1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.4,260.12v-4a1.36,1.36,0,0,1,1.34-1.38h14.31a1.36,1.36,0,0,1,1.33,1.38v4a1.36,1.36,0,0,1-1.33,1.38H561.74A1.36,1.36,0,0,1,560.4,260.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.05,261.87H561.74a1.74,1.74,0,0,1-1.71-1.75v-4a1.74,1.74,0,0,1,1.71-1.75h14.31a1.74,1.74,0,0,1,1.71,1.75v4A1.74,1.74,0,0,1,576.05,261.87Zm-14.31-6.79a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h14.31a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.54,362.66h-73.7a10.14,10.14,0,0,1-10.15-10.15l9.4-91.74a8.11,8.11,0,0,1,8.12-8.12h59a8.12,8.12,0,0,1,8.12,8.12l9.4,91.74A10.15,10.15,0,0,1,610.54,362.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.54,363.16h-73.7a10.66,10.66,0,0,1-10.65-10.65l9.4-91.79a8.61,8.61,0,0,1,8.62-8.57h59a8.63,8.63,0,0,1,8.62,8.62l9.39,91.69A10.66,10.66,0,0,1,610.54,363.16Zm-66.33-110a7.63,7.63,0,0,0-7.62,7.62l-9.41,91.79a9.67,9.67,0,0,0,9.66,9.6h73.7a9.66,9.66,0,0,0,9.65-9.65l-9.4-91.69a7.64,7.64,0,0,0-7.62-7.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.93 348.76 587.74 320.51 608.4 400.4 529.98 400.4 519.93 348.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.05,400.9H529.57l-.08-.4-10.13-52.05.38-.15,68.34-28.47Zm-78.66-1h77.37L587.4,321.2l-66.9,27.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.4,
    cy: 357.89,
    r: 42.51,
    transform: "translate(-65.06 146.51) rotate(-13.04)",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.4,400.9a43,43,0,1,1,43-43A43.06,43.06,0,0,1,608.4,400.9Zm0-85a42,42,0,1,0,42,42A42.06,42.06,0,0,0,608.4,315.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.98,
    cy: 373.65,
    r: 26.76,
    transform: "translate(-53.39 90.51) rotate(-9.3)",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,400.9a27.26,27.26,0,1,1,27.26-27.25A27.28,27.28,0,0,1,530,400.9Zm0-53.51a26.26,26.26,0,1,0,26.26,26.26A26.29,26.29,0,0,0,530,347.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 529.98,
    cy: 373.65,
    r: 19.08,
    transform: "translate(-51.99 87.63) rotate(-9.01)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,393.22a19.58,19.58,0,1,1,19.58-19.57A19.6,19.6,0,0,1,530,393.22Zm0-38.15a18.58,18.58,0,1,0,18.58,18.58A18.6,18.6,0,0,0,530,355.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.4,
    cy: 357.89,
    r: 31.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.4,390.13a32.24,32.24,0,1,1,32.23-32.24A32.27,32.27,0,0,1,608.4,390.13Zm0-63.47a31.24,31.24,0,1,0,31.23,31.23A31.27,31.27,0,0,0,608.4,326.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.58,
    y: 347.9,
    width: 1,
    height: 31.57,
    transform: "translate(56.08 809.79) rotate(-68.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 608.4,
    cy: 357.89,
    r: 4.17,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.4,362.57a4.68,4.68,0,1,1,4.68-4.68A4.68,4.68,0,0,1,608.4,362.57Zm0-8.35a3.68,3.68,0,1,0,3.68,3.67A3.68,3.68,0,0,0,608.4,354.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.98,
    y1: 373.65,
    x2: 513.04,
    y2: 382.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.99,
    y: 377.5,
    width: 19.04,
    height: 1,
    transform: "translate(-115.14 280.36) rotate(-27.22)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.16,373.65a4.18,4.18,0,1,0-4.18,4.17A4.18,4.18,0,0,0,534.16,373.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530,378.32a4.68,4.68,0,1,1,4.68-4.67A4.68,4.68,0,0,1,530,378.32Zm0-8.35a3.68,3.68,0,1,0,3.68,3.68A3.68,3.68,0,0,0,530,370Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.34,298.49l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l2.9-12.06a1.14,1.14,0,0,1,1.38-.85l3.25.78a1.15,1.15,0,0,1,.85,1.39l-2.9,12.06A1.15,1.15,0,0,1,580.34,298.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.61,298.85a1.45,1.45,0,0,1-.35,0L577,298a1.47,1.47,0,0,1-.91-.67,1.5,1.5,0,0,1-.17-1.12l2.9-12.05a1.48,1.48,0,0,1,1.78-1.1l3.25.78a1.44,1.44,0,0,1,.91.67,1.46,1.46,0,0,1,.17,1.12l-2.9,12a1.48,1.48,0,0,1-.66.92A1.43,1.43,0,0,1,580.61,298.85Zm-.34-15.15a.83.83,0,0,0-.8.64l-2.91,12.06a.87.87,0,0,0,.1.63.85.85,0,0,0,.51.37l3.25.78a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52l2.9-12.06a.79.79,0,0,0-.1-.62.83.83,0,0,0-.5-.38l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.12,298.7l-3.25-.78a1.14,1.14,0,0,1-.84-1.39l3.24-13.46a1.14,1.14,0,0,1,1.38-.86l3.25.78a1.14,1.14,0,0,1,.84,1.39l-3.24,13.47A1.14,1.14,0,0,1,578.12,298.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.39,299.06a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.44,1.44,0,0,1-.9-.66,1.49,1.49,0,0,1-.18-1.13L577,283a1.49,1.49,0,0,1,1.78-1.1l3.25.78a1.49,1.49,0,0,1,1.08,1.79l-3.24,13.46a1.48,1.48,0,0,1-.66.92A1.43,1.43,0,0,1,578.39,299.06Zm0-16.56a.83.83,0,0,0-.81.64l-3.24,13.47a.87.87,0,0,0,.1.63.82.82,0,0,0,.51.36l3.25.79a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52l3.24-13.46a.82.82,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.5,300.46l-3.25-.78a1.16,1.16,0,0,1-.85-1.4l2.91-12.06a1.14,1.14,0,0,1,1.38-.85l3.25.78a1.14,1.14,0,0,1,.84,1.39l-2.9,12.06A1.15,1.15,0,0,1,588.5,300.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.77,300.81a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.46,1.46,0,0,1-.91-.66,1.52,1.52,0,0,1-.17-1.12l2.9-12.06a1.48,1.48,0,0,1,1.78-1.1l3.25.78a1.48,1.48,0,0,1,1.08,1.79l-2.9,12.06a1.46,1.46,0,0,1-.66.91A1.43,1.43,0,0,1,588.77,300.81Zm-.35-15.15a.83.83,0,0,0-.8.64l-2.9,12.06a.82.82,0,0,0,.1.63.78.78,0,0,0,.5.37l3.25.78a.79.79,0,0,0,.62-.1.88.88,0,0,0,.38-.51l2.9-12.06a.82.82,0,0,0-.1-.63.78.78,0,0,0-.51-.37l-3.25-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.46,
    y: 289.6,
    width: 16.16,
    height: 5.63,
    rx: 1.16,
    transform: "translate(164.99 794.25) rotate(-76.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.55,301a1.34,1.34,0,0,1-.35,0L583,300.2a1.47,1.47,0,0,1-1.08-1.78L585.11,285a1.47,1.47,0,0,1,1.77-1.09l3.25.78a1.48,1.48,0,0,1,1.09,1.78L588,299.89a1.52,1.52,0,0,1-.67.92A1.48,1.48,0,0,1,586.55,301Zm0-16.55a.82.82,0,0,0-.8.63l-3.24,13.47a.83.83,0,0,0,.6,1l3.25.78a.82.82,0,0,0,1-.61l3.24-13.47a.83.83,0,0,0-.6-1l-3.25-.78A.62.62,0,0,0,586.54,284.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.65,302.42l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l2.9-12.06a1.16,1.16,0,0,1,1.39-.86l3.25.78a1.16,1.16,0,0,1,.84,1.4L598,301.56A1.15,1.15,0,0,1,596.65,302.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.92,302.78a2,2,0,0,1-.34,0l-3.25-.79a1.4,1.4,0,0,1-.91-.66,1.47,1.47,0,0,1-.18-1.12l2.91-12.06a1.48,1.48,0,0,1,1.77-1.1l3.25.79a1.48,1.48,0,0,1,1.09,1.78l-2.91,12.06a1.47,1.47,0,0,1-.66.92A1.5,1.5,0,0,1,596.92,302.78Zm-.34-15.15a.82.82,0,0,0-.8.63l-2.9,12.06a.81.81,0,0,0,.09.63.83.83,0,0,0,.51.37l3.25.78a.76.76,0,0,0,.62-.1.78.78,0,0,0,.37-.51l2.9-12.06a.82.82,0,0,0-.6-1l-3.25-.78A.62.62,0,0,0,596.58,287.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43,302.63l-3.25-.78a1.16,1.16,0,0,1-.84-1.4L593.58,287a1.14,1.14,0,0,1,1.38-.85l3.25.78a1.15,1.15,0,0,1,.85,1.39l-3.24,13.46A1.16,1.16,0,0,1,594.43,302.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.7,303a2,2,0,0,1-.34,0l-3.25-.79a1.43,1.43,0,0,1-.91-.66,1.46,1.46,0,0,1-.18-1.12l3.24-13.46a1.48,1.48,0,0,1,1.78-1.1l3.25.78a1.48,1.48,0,0,1,1.08,1.79l-3.24,13.46A1.47,1.47,0,0,1,594.7,303Zm0-16.56a.83.83,0,0,0-.8.64l-3.24,13.46a.81.81,0,0,0,.09.63.83.83,0,0,0,.51.37l3.25.78a.76.76,0,0,0,.62-.1.8.8,0,0,0,.37-.51l3.24-13.47a.83.83,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.81,304.38l-3.25-.78a1.14,1.14,0,0,1-.84-1.39l2.9-12.06a1.16,1.16,0,0,1,1.38-.86l3.25.79a1.15,1.15,0,0,1,.85,1.39l-2.91,12.06A1.14,1.14,0,0,1,604.81,304.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.08,304.74a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.47,1.47,0,0,1-.91-.67,1.51,1.51,0,0,1-.17-1.12l2.9-12.06a1.48,1.48,0,0,1,1.78-1.09l3.25.78a1.47,1.47,0,0,1,1.08,1.78l-2.9,12.06a1.48,1.48,0,0,1-.66.92A1.43,1.43,0,0,1,605.08,304.74Zm-.34-15.15a.83.83,0,0,0-.81.64L601,302.29a.8.8,0,0,0,.1.62.78.78,0,0,0,.5.37l3.26.79a.85.85,0,0,0,.62-.1.86.86,0,0,0,.37-.52l2.9-12.06a.83.83,0,0,0-.6-1l-3.25-.78A.65.65,0,0,0,604.74,289.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.59,304.59l-3.25-.78a1.16,1.16,0,0,1-.85-1.39L601.73,289a1.15,1.15,0,0,1,1.39-.85l3.25.78a1.15,1.15,0,0,1,.84,1.39L604,303.74A1.14,1.14,0,0,1,602.59,304.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.86,305a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.48,1.48,0,0,1-.9-.66,1.49,1.49,0,0,1-.18-1.13l3.24-13.46a1.47,1.47,0,0,1,1.78-1.1l3.25.78a1.49,1.49,0,0,1,1.08,1.79l-3.24,13.46a1.48,1.48,0,0,1-.66.92A1.52,1.52,0,0,1,602.86,305Zm0-16.56a.83.83,0,0,0-.8.64l-3.24,13.46a.84.84,0,0,0,.1.64.8.8,0,0,0,.5.36l3.25.79a.83.83,0,0,0,.62-.1.87.87,0,0,0,.38-.52l3.24-13.46a.83.83,0,0,0-.61-1l-3.25-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,306.35l-3.26-.79a1.15,1.15,0,0,1-.84-1.39l2.9-12.06a1.15,1.15,0,0,1,1.39-.85l3.25.78a1.15,1.15,0,0,1,.84,1.39l-2.9,12.06A1.16,1.16,0,0,1,613,306.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.23,306.7a1.32,1.32,0,0,1-.34,0l-3.25-.78a1.49,1.49,0,0,1-1.09-1.78L611.46,292a1.47,1.47,0,0,1,1.77-1.1l3.25.78a1.48,1.48,0,0,1,1.09,1.79l-2.9,12.06a1.48,1.48,0,0,1-.67.91A1.41,1.41,0,0,1,613.23,306.7Zm-.34-15.15a.83.83,0,0,0-.8.64l-2.9,12.06a.82.82,0,0,0,.09.63.87.87,0,0,0,.51.37L613,306a.84.84,0,0,0,.62-.1.82.82,0,0,0,.37-.52l2.91-12.05a.83.83,0,0,0-.61-1l-3.25-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.74,306.55l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l3.24-13.46a1.16,1.16,0,0,1,1.39-.86l3.25.78a1.16,1.16,0,0,1,.84,1.4l-3.24,13.46A1.15,1.15,0,0,1,610.74,306.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,306.91a1.32,1.32,0,0,1-.34,0l-3.25-.78a1.48,1.48,0,0,1-1.09-1.79l3.24-13.46a1.5,1.5,0,0,1,1.78-1.1l3.25.79a1.48,1.48,0,0,1,1.09,1.78l-3.24,13.47a1.5,1.5,0,0,1-.67.91A1.41,1.41,0,0,1,611,306.91Zm0-16.56a.83.83,0,0,0-.8.64L607,304.46a.83.83,0,0,0,.6,1l3.25.78a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52l3.24-13.46a.82.82,0,0,0-.6-1l-3.25-.78A.63.63,0,0,0,611,290.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.12,308.31l-3.25-.78a1.16,1.16,0,0,1-.84-1.4l2.9-12.05a1.15,1.15,0,0,1,1.38-.86l3.25.78a1.15,1.15,0,0,1,.85,1.39l-2.9,12.06A1.16,1.16,0,0,1,621.12,308.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.39,308.67a2,2,0,0,1-.34,0l-3.25-.79a1.43,1.43,0,0,1-.91-.66,1.47,1.47,0,0,1-.18-1.12l2.9-12.06a1.49,1.49,0,0,1,1.78-1.1l3.25.79a1.47,1.47,0,0,1,1.08,1.78l-2.9,12.06a1.47,1.47,0,0,1-1.43,1.14Zm-.34-15.16a.83.83,0,0,0-.8.64l-2.91,12.06a.86.86,0,0,0,.1.63.83.83,0,0,0,.51.37l3.25.78a.82.82,0,0,0,1-.61l2.9-12.06a.82.82,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.9,308.52l-3.25-.78a1.15,1.15,0,0,1-.84-1.4l3.24-13.46a1.16,1.16,0,0,1,1.38-.86l3.25.79a1.15,1.15,0,0,1,.85,1.39l-3.25,13.46A1.14,1.14,0,0,1,618.9,308.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.17,308.88a1.41,1.41,0,0,1-.35-.05l-3.25-.78a1.48,1.48,0,0,1-1.08-1.78l3.24-13.47a1.48,1.48,0,0,1,1.78-1.09l3.25.78a1.47,1.47,0,0,1,1.08,1.78l-3.24,13.47a1.46,1.46,0,0,1-.66.91A1.44,1.44,0,0,1,619.17,308.88Zm0-16.56a.83.83,0,0,0-.81.64l-3.24,13.46a.84.84,0,0,0,.61,1l3.25.78a.82.82,0,0,0,1-.61l3.24-13.47a.83.83,0,0,0-.6-1l-3.25-.78A.65.65,0,0,0,619.17,292.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.02,
    y: 299.91,
    width: 14.72,
    height: 5.63,
    rx: 1.15,
    transform: "translate(187.78 843.79) rotate(-76.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.55,310.63a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.53,1.53,0,0,1-.91-.66,1.49,1.49,0,0,1-.17-1.13l2.9-12.06a1.48,1.48,0,0,1,1.78-1.09l3.25.78a1.47,1.47,0,0,1,1.08,1.78L631,309.49a1.48,1.48,0,0,1-.66.92A1.52,1.52,0,0,1,629.55,310.63Zm-.34-15.15a.82.82,0,0,0-.81.64l-2.9,12.05a.84.84,0,0,0,.1.64.8.8,0,0,0,.5.36l3.25.79a.83.83,0,0,0,.62-.1.87.87,0,0,0,.38-.52l2.9-12.06a.84.84,0,0,0-.61-1l-3.25-.78A.55.55,0,0,0,629.21,295.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.06,310.48l-3.25-.78a1.15,1.15,0,0,1-.85-1.39l3.24-13.47a1.15,1.15,0,0,1,1.39-.85l3.25.78a1.15,1.15,0,0,1,.84,1.39l-3.24,13.46A1.14,1.14,0,0,1,627.06,310.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.33,310.84a2,2,0,0,1-.35,0l-3.25-.79a1.43,1.43,0,0,1-.91-.66,1.47,1.47,0,0,1-.17-1.12l3.24-13.46a1.47,1.47,0,0,1,1.77-1.1l3.25.78a1.48,1.48,0,0,1,1.09,1.79l-3.24,13.46a1.52,1.52,0,0,1-.67.92A1.49,1.49,0,0,1,627.33,310.84Zm0-16.56a.83.83,0,0,0-.8.64l-3.24,13.46a.82.82,0,0,0,.1.63.78.78,0,0,0,.5.37l3.25.78a.75.75,0,0,0,.62-.1.8.8,0,0,0,.37-.51l3.24-13.47a.83.83,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.43,312.23l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l2.9-12.06a1.15,1.15,0,0,1,1.39-.85l3.25.78a1.15,1.15,0,0,1,.84,1.39l-2.9,12.06A1.15,1.15,0,0,1,637.43,312.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.7,312.59a1.32,1.32,0,0,1-.34,0l-3.25-.78A1.48,1.48,0,0,1,633,310l2.9-12.05a1.48,1.48,0,0,1,1.78-1.1l3.25.78A1.48,1.48,0,0,1,642,299.4l-2.91,12.06a1.45,1.45,0,0,1-.66.91A1.41,1.41,0,0,1,637.7,312.59Zm-.34-15.15a.83.83,0,0,0-.8.64l-2.9,12.06a.83.83,0,0,0,.6,1l3.25.78a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52l2.9-12.06a.83.83,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.21,312.44l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l3.24-13.46a1.14,1.14,0,0,1,1.38-.86l3.25.78a1.15,1.15,0,0,1,.85,1.39l-3.24,13.47A1.15,1.15,0,0,1,635.21,312.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.48,312.8a1.32,1.32,0,0,1-.34,0l-3.25-.78a1.46,1.46,0,0,1-.91-.66,1.49,1.49,0,0,1-.18-1.13L634,296.73a1.49,1.49,0,0,1,1.78-1.1l3.25.79a1.47,1.47,0,0,1,1.08,1.78l-3.24,13.46a1.44,1.44,0,0,1-.66.92A1.41,1.41,0,0,1,635.48,312.8Zm0-16.56a.83.83,0,0,0-.8.64l-3.24,13.47a.82.82,0,0,0,.09.63.85.85,0,0,0,.51.36l3.25.79a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52l3.24-13.46a.82.82,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.59,314.2l-3.25-.78a1.15,1.15,0,0,1-.84-1.4L644.4,300a1.14,1.14,0,0,1,1.38-.85l3.25.78a1.15,1.15,0,0,1,.85,1.39L647,313.34A1.15,1.15,0,0,1,645.59,314.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.86,314.55a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.41,1.41,0,0,1-.9-.66,1.47,1.47,0,0,1-.18-1.12l2.9-12.06a1.49,1.49,0,0,1,1.78-1.1l3.25.78a1.48,1.48,0,0,1,1.08,1.79l-2.9,12.06a1.46,1.46,0,0,1-.66.91A1.43,1.43,0,0,1,645.86,314.55Zm-.34-15.15a.84.84,0,0,0-.81.64l-2.9,12.06a.86.86,0,0,0,.1.63.8.8,0,0,0,.51.37l3.25.78a.8.8,0,0,0,.62-.1.84.84,0,0,0,.37-.51l2.9-12.06a.82.82,0,0,0-.6-1l-3.25-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.37,314.41l-3.25-.79a1.15,1.15,0,0,1-.85-1.39l3.25-13.46a1.14,1.14,0,0,1,1.38-.86l3.25.78a1.15,1.15,0,0,1,.84,1.4l-3.24,13.46A1.16,1.16,0,0,1,643.37,314.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.64,314.76a1.39,1.39,0,0,1-.35,0l-3.25-.78a1.47,1.47,0,0,1-1.08-1.78l3.24-13.47A1.48,1.48,0,0,1,644,297.6l3.25.78a1.48,1.48,0,0,1,1.08,1.78l-3.24,13.47a1.46,1.46,0,0,1-.66.91A1.43,1.43,0,0,1,643.64,314.76Zm0-16.55a.82.82,0,0,0-.8.63l-3.24,13.47a.83.83,0,0,0,.6,1l3.25.78a.79.79,0,0,0,.62-.1.87.87,0,0,0,.38-.52L647.68,300a.84.84,0,0,0-.61-1l-3.25-.78A.58.58,0,0,0,643.63,298.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.75,316.16l-3.25-.78a1.15,1.15,0,0,1-.85-1.39l2.9-12.06a1.16,1.16,0,0,1,1.39-.86l3.25.78a1.16,1.16,0,0,1,.84,1.4l-2.9,12.05A1.14,1.14,0,0,1,653.75,316.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654,316.52a2,2,0,0,1-.34,0l-3.25-.79a1.45,1.45,0,0,1-.91-.66,1.41,1.41,0,0,1-.17-1.12l2.9-12.06a1.49,1.49,0,0,1,1.77-1.1l3.25.79a1.48,1.48,0,0,1,1.09,1.78l-2.9,12.06a1.52,1.52,0,0,1-.67.92A1.5,1.5,0,0,1,654,316.52Zm-.34-15.15a.82.82,0,0,0-.8.63L650,314.06a.82.82,0,0,0,.1.63.78.78,0,0,0,.5.37l3.25.78a.75.75,0,0,0,.62-.1.8.8,0,0,0,.37-.51l2.91-12.06a.84.84,0,0,0-.61-1l-3.25-.78A.58.58,0,0,0,653.67,301.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.52,316.37l-3.25-.78a1.16,1.16,0,0,1-.84-1.4l3.24-13.46a1.15,1.15,0,0,1,1.39-.85l3.25.78a1.15,1.15,0,0,1,.84,1.39l-3.24,13.46A1.16,1.16,0,0,1,651.52,316.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.79,316.73a2,2,0,0,1-.34,0l-3.25-.79a1.48,1.48,0,0,1-1.09-1.78l3.24-13.46a1.48,1.48,0,0,1,1.78-1.1l3.25.78a1.48,1.48,0,0,1,1.09,1.79l-3.24,13.46a1.52,1.52,0,0,1-.67.92A1.5,1.5,0,0,1,651.79,316.73Zm0-16.56a.83.83,0,0,0-.8.64l-3.24,13.46a.82.82,0,0,0,.6,1l3.25.78a.76.76,0,0,0,.62-.1.8.8,0,0,0,.37-.51L655.83,302a.83.83,0,0,0-.6-1l-3.25-.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.9,318.12l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l2.9-12.06a1.16,1.16,0,0,1,1.38-.86l3.25.79a1.15,1.15,0,0,1,.85,1.39l-2.9,12.06A1.15,1.15,0,0,1,661.9,318.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.17,318.48a1.32,1.32,0,0,1-.34,0l-3.25-.78a1.46,1.46,0,0,1-.91-.66,1.49,1.49,0,0,1-.18-1.13l2.9-12.06a1.48,1.48,0,0,1,1.78-1.09l3.25.78a1.48,1.48,0,0,1,1.08,1.79l-2.9,12a1.48,1.48,0,0,1-.66.92A1.43,1.43,0,0,1,662.17,318.48Zm-.34-15.15a.82.82,0,0,0-.8.64L658.12,316a.87.87,0,0,0,.1.63.85.85,0,0,0,.51.36l3.25.79a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52l2.9-12.06a.83.83,0,0,0-.6-1l-3.25-.78A.65.65,0,0,0,661.83,303.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.68,318.33l-3.25-.78a1.15,1.15,0,0,1-.84-1.39l3.24-13.47a1.14,1.14,0,0,1,1.38-.85l3.25.78a1.16,1.16,0,0,1,.85,1.39l-3.24,13.47A1.15,1.15,0,0,1,659.68,318.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660,318.69a1.45,1.45,0,0,1-.35,0l-3.25-.78a1.49,1.49,0,0,1-1.08-1.79l3.24-13.46a1.48,1.48,0,0,1,.66-.92,1.51,1.51,0,0,1,1.12-.18l3.25.78a1.48,1.48,0,0,1,1.08,1.79l-3.24,13.46a1.48,1.48,0,0,1-.66.92A1.52,1.52,0,0,1,660,318.69Zm0-16.56a.81.81,0,0,0-.42.12.87.87,0,0,0-.38.52l-3.24,13.46a.83.83,0,0,0,.61,1l3.25.79a.85.85,0,0,0,.62-.1.82.82,0,0,0,.37-.52L664,303.94a.82.82,0,0,0-.6-1l-3.25-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.33,
    cy: 289.72,
    r: 21.35,
    transform: "translate(-51.5 141.3) rotate(-13.41)",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.33,311.58a21.86,21.86,0,1,1,21.86-21.86A21.88,21.88,0,0,1,575.33,311.58Zm0-42.71a20.86,20.86,0,1,0,20.86,20.85A20.88,20.88,0,0,0,575.33,268.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 554.34,
    y1: 285.07,
    x2: 575.33,
    y2: 289.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.34,
    y: 276.65,
    width: 1,
    height: 21.51,
    transform: "translate(162.16 776.78) rotate(-77.52)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.33,
    cy: 289.72,
    r: 10.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.33,300.76a11,11,0,1,1,11-11A11,11,0,0,1,575.33,300.76Zm0-21.07a10,10,0,1,0,10,10A10,10,0,0,0,575.33,279.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.52,324.86h10.87a3.53,3.53,0,0,0,3.53-3.53V273.08a3.53,3.53,0,0,0-3.53-3.53h-5.2Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.39,325.36H529l5.77-56.31h5.65a4,4,0,0,1,4,4v48.25A4,4,0,0,1,540.39,325.36Zm-10.32-1h10.32a3,3,0,0,0,3-3V273.08a3,3,0,0,0-3-3h-4.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "272.23 357.27 235.15 334.92 235.15 156.15 272.23 133.8 272.23 357.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.73,358.15l-38.08-22.94V155.87l38.08-23Zm-37.08-23.51,36.08,21.74V134.69l-36.08,21.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,232.67,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,240.54h-4a1.74,1.74,0,0,1-1.75-1.71V224.52a1.74,1.74,0,0,1,1.75-1.71h4a1.74,1.74,0,0,1,1.75,1.71v14.31A1.74,1.74,0,0,1,232.67,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.12,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,230.12,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.12,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,230.12,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.78,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,242.78,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.78,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,242.78,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.24,241h-4a1.36,1.36,0,0,1-1.39-1.34v-16a1.36,1.36,0,0,1,1.39-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,240.24,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.24,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.72,1.72,0,0,1,1.75,1.71v16A1.72,1.72,0,0,1,240.24,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,252.9,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,240.54h-4a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h4a1.74,1.74,0,0,1,1.76,1.71v14.31A1.74,1.74,0,0,1,252.9,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.39,1.34v16A1.36,1.36,0,0,1,250.35,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.35,241.37h-4a1.72,1.72,0,0,1-1.75-1.71v-16a1.72,1.72,0,0,1,1.75-1.71h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,250.35,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,240.16h-4a1.35,1.35,0,0,1-1.38-1.33V224.52a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v14.31A1.35,1.35,0,0,1,263,240.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,240.54h-4a1.74,1.74,0,0,1-1.75-1.71V224.52a1.74,1.74,0,0,1,1.75-1.71h4a1.74,1.74,0,0,1,1.75,1.71v14.31A1.74,1.74,0,0,1,263,240.54Zm-4-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V224.52a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.47,241h-4a1.36,1.36,0,0,1-1.38-1.34v-16a1.36,1.36,0,0,1,1.38-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,260.47,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.47,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.73,1.73,0,0,1,1.76,1.71v16A1.73,1.73,0,0,1,260.47,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.52,223.18H269.1a1.36,1.36,0,0,0-1.38,1.34v14.31a1.35,1.35,0,0,0,1.38,1.33h3.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89,240.54H269.1a1.74,1.74,0,0,1-1.76-1.71V224.52a1.74,1.74,0,0,1,1.76-1.71h3.79Zm-3.79-17a1,1,0,0,0-1,1v14.31a1,1,0,0,0,1,1h3V223.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.59,241h-4a1.36,1.36,0,0,1-1.39-1.34v-16a1.36,1.36,0,0,1,1.39-1.34h4a1.36,1.36,0,0,1,1.38,1.34v16A1.36,1.36,0,0,1,270.59,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.59,241.37h-4a1.73,1.73,0,0,1-1.76-1.71v-16a1.73,1.73,0,0,1,1.76-1.71h4a1.72,1.72,0,0,1,1.75,1.71v16A1.72,1.72,0,0,1,270.59,241.37Zm-4-18.64a1,1,0,0,0-1,1v16a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-16a1,1,0,0,0-1-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.92 184.61 217.84 169.76 215.23 188.77 205.92 184.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.63,189.5l-10.51-4.69L218.59,168Zm-8.92-5.08,8.11,3.63,2.28-16.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.1,193.82c-1.26,2.83-6.44,3.28-11.57,1s-8.25-6.44-7-9.27,6.45-3.29,11.57-1S219.37,191,218.1,193.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,196.78a16.22,16.22,0,0,1-6.51-1.51,15.48,15.48,0,0,1-6.09-4.58c-1.43-1.9-1.84-3.8-1.15-5.35,1.39-3.13,6.76-3.69,12.22-1.25s8.65,6.79,7.25,9.93h0c-.69,1.55-2.38,2.51-4.75,2.72C213.49,196.76,213.17,196.78,212.84,196.78Zm-8-13.18c-2.34,0-4.17.73-4.8,2.15-.54,1.2-.17,2.74,1,4.34a16,16,0,0,0,12.68,5.65c2-.17,3.39-.93,3.92-2.13h0c1.14-2.53-1.95-6.48-6.73-8.61A15.45,15.45,0,0,0,204.8,183.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81,193.42h4.88a0,0,0,0,1,0,0v36.28a0,0,0,0,1,0,0h-4.88a9.27,9.27,0,0,1-9.27-9.27V202.69A9.27,9.27,0,0,1,151.81,193.42Z",
    transform: "translate(99.07 -42.58) rotate(24.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,231.67,144,229.48a9.78,9.78,0,0,1-4.95-12.9l7.23-16.21a9.79,9.79,0,0,1,12.9-4.94l4.91,2.19Zm6.29-36.09a8.77,8.77,0,0,0-8,5.2L140,217a8.77,8.77,0,0,0,4.44,11.58l4,1.78,14.36-32.22-4-1.79A8.84,8.84,0,0,0,155.24,195.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.33,230.19h4.88a0,0,0,0,1,0,0v36.28a0,0,0,0,1,0,0h-4.88a9.27,9.27,0,0,1-9.27-9.27V239.46A9.27,9.27,0,0,1,234.33,230.19Z",
    transform: "translate(343.1 569.66) rotate(-155.98)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.51,265.32a9.77,9.77,0,0,1-4-.85l-4.92-2.19,15.18-34.06,4.91,2.2a9.77,9.77,0,0,1,4.95,12.89l-7.22,16.21A9.78,9.78,0,0,1,226.51,265.32ZM219,261.77l4,1.79a8.77,8.77,0,0,0,11.57-4.44l7.23-16.21a8.78,8.78,0,0,0-4.44-11.58l-4-1.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.81,
    cy: 230.5,
    r: 45.33,
    transform: "translate(-69.88 83.61) rotate(-20.98)",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79,276.35a45.85,45.85,0,1,1,41.88-27.2h0a45.92,45.92,0,0,1-41.88,27.2Zm0-90.71a44.95,44.95,0,1,0,18.24,3.91A44.76,44.76,0,0,0,190.82,185.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.09,
    cy: 242.21,
    rx: 35.03,
    ry: 16.56,
    transform: "translate(-92.51 341.92) rotate(-65.98)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.57,274.8l-.18-.37a45.83,45.83,0,0,1,28.83-64.7l.39-.11.19.37A45.85,45.85,0,0,1,203,274.69Zm28.51-64a44.82,44.82,0,0,0-28,62.8,44.82,44.82,0,0,0,28-62.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.64,
    cy: 218.39,
    rx: 34.2,
    ry: 15.59,
    transform: "translate(-102.45 278.98) rotate(-65.98)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.46,250.24l-.19-.4a45.78,45.78,0,0,1,28.15-63.16l.41-.13.19.39a45.82,45.82,0,0,1-28.15,63.17Zm27.83-62.48A44.8,44.8,0,0,0,150,249a44.79,44.79,0,0,0,27.29-61.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 210.83,
    width: 64.22,
    height: 35.92,
    rx: 7.66,
    transform: "translate(109.54 -57.37) rotate(24.02)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.75,256.31a8,8,0,0,1-3.32-.71l-44.67-19.9a8.17,8.17,0,0,1-4.13-10.77L164,206.1A8.17,8.17,0,0,1,174.78,202l44.68,19.91a8.16,8.16,0,0,1,4.13,10.77l-8.39,18.82a8.07,8.07,0,0,1-4.53,4.3A8.24,8.24,0,0,1,207.75,256.31Zm-36.28-54.05a7.17,7.17,0,0,0-6.54,4.25l-8.39,18.82a7.16,7.16,0,0,0,3.62,9.45l44.68,19.91a7.18,7.18,0,0,0,9.45-3.62l8.39-18.83a7.17,7.17,0,0,0-3.63-9.45l-44.67-19.9A7.06,7.06,0,0,0,171.47,202.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,224.15a4.71,4.71,0,1,0-6.23,2.39A4.71,4.71,0,0,0,178.76,224.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,227.45a5.21,5.21,0,0,1-4.87-3.35,5.16,5.16,0,0,1,.11-4,5.22,5.22,0,0,1,2.9-2.75,5.22,5.22,0,0,1,6.63,7h0a5.17,5.17,0,0,1-2.9,2.74A5,5,0,0,1,174.45,227.45Zm0-9.43a4.22,4.22,0,0,0-3.86,2.5,4.23,4.23,0,0,0,2.14,5.57,4.23,4.23,0,0,0,3.22.08,4.17,4.17,0,0,0,2.35-2.22h0a4.23,4.23,0,0,0-2.14-5.57A4.27,4.27,0,0,0,174.46,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,237.74a4.71,4.71,0,1,0-6.22,2.39A4.72,4.72,0,0,0,209.25,237.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.94,241a5.32,5.32,0,0,1-2.12-.45,5.22,5.22,0,1,1,6.89-2.65h0A5.22,5.22,0,0,1,204.94,241Zm0-9.44a4.23,4.23,0,1,0,1.71.37A4.15,4.15,0,0,0,205,231.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,168.46a4.72,4.72,0,1,0-6.23,2.39A4.72,4.72,0,0,0,223.85,168.46Z",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.53,171.76a5.21,5.21,0,1,1,4.78-3.1h0A5.24,5.24,0,0,1,219.53,171.76Zm0-9.44a4.22,4.22,0,1,0,1.71.37A4.18,4.18,0,0,0,219.55,162.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,154l2.36,2.45a1.17,1.17,0,0,1,0,1.65l-8.94,8.59a1.17,1.17,0,0,1-1.64,0l-2.36-2.46a1.16,1.16,0,0,1,0-1.64l9-8.59A1.15,1.15,0,0,1,145.51,154Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1,167.33a1.49,1.49,0,0,1-1.08-.46l-2.36-2.45a1.51,1.51,0,0,1-.41-1.07,1.44,1.44,0,0,1,.45-1l8.94-8.59a1.52,1.52,0,0,1,1.06-.41,1.45,1.45,0,0,1,1,.46l2.36,2.46a1.46,1.46,0,0,1,.42,1.06,1.41,1.41,0,0,1-.45,1l-8.95,8.59A1.43,1.43,0,0,1,138.1,167.33ZM144.67,154a.83.83,0,0,0-.58.23l-8.94,8.59a.85.85,0,0,0,0,1.18l2.36,2.46a.83.83,0,0,0,1.18,0l9-8.59a.83.83,0,0,0,0-1.18l-2.35-2.46a.89.89,0,0,0-.59-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,155.05l2.36,2.45a1.17,1.17,0,0,1,0,1.65l-10,9.59a1.18,1.18,0,0,1-1.65,0l-2.35-2.46a1.16,1.16,0,0,1,0-1.64l10-9.59A1.15,1.15,0,0,1,147.52,155.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.07,169.38h0a1.49,1.49,0,0,1-1-.46l-2.36-2.45a1.5,1.5,0,0,1,0-2.11l10-9.59a1.55,1.55,0,0,1,1.06-.41,1.5,1.5,0,0,1,1,.46l2.35,2.46a1.44,1.44,0,0,1,.42,1.06,1.41,1.41,0,0,1-.45,1l-10,9.59A1.44,1.44,0,0,1,139.07,169.38ZM146.68,155a.83.83,0,0,0-.58.23l-10,9.59a.85.85,0,0,0,0,1.19l2.36,2.45a.83.83,0,0,0,.59.26.75.75,0,0,0,.59-.23l10-9.59a.79.79,0,0,0,.25-.58.82.82,0,0,0-.23-.6l-2.36-2.46a.89.89,0,0,0-.59-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.59,147.83l2.36,2.46a1.15,1.15,0,0,1,0,1.64L133,160.52a1.15,1.15,0,0,1-1.64,0L129,158a1.17,1.17,0,0,1,0-1.65l8.95-8.59A1.17,1.17,0,0,1,139.59,147.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18,161.17h0a1.49,1.49,0,0,1-1-.46l-2.36-2.46a1.49,1.49,0,0,1,0-2.1l8.94-8.59a1.49,1.49,0,0,1,2.1.05l2.36,2.45a1.5,1.5,0,0,1,0,2.11l-9,8.59A1.46,1.46,0,0,1,132.18,161.17Zm6.57-13.37a.83.83,0,0,0-.58.23l-8.94,8.59a.84.84,0,0,0,0,1.18l2.36,2.46a.83.83,0,0,0,1.18,0l8.95-8.59a.85.85,0,0,0,0-1.19l-2.36-2.45a.84.84,0,0,0-.59-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.6,148.88l2.36,2.46a1.15,1.15,0,0,1,0,1.64l-10,9.59a1.16,1.16,0,0,1-1.65,0L130,160.08a1.17,1.17,0,0,1,0-1.65l10-9.59A1.17,1.17,0,0,1,141.6,148.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,163.22h0a1.49,1.49,0,0,1-1-.46l-2.36-2.46a1.52,1.52,0,0,1-.42-1.06,1.49,1.49,0,0,1,.46-1l10-9.59a1.49,1.49,0,0,1,2.11,0l2.35,2.45a1.47,1.47,0,0,1,.42,1.06,1.44,1.44,0,0,1-.45,1.05l-10,9.59A1.48,1.48,0,0,1,133.15,163.22Zm7.61-14.37a.81.81,0,0,0-.58.23l-10,9.59a.84.84,0,0,0-.26.58.83.83,0,0,0,.24.6l2.36,2.46a.87.87,0,0,0,.59.26.78.78,0,0,0,.59-.23l10-9.59a.82.82,0,0,0,.25-.59.85.85,0,0,0-.23-.6l-2.36-2.45A.87.87,0,0,0,140.76,148.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.81,140.85a20.91,20.91,0,0,1,4.08,3.16,1.51,1.51,0,0,1,.39.51,1.32,1.32,0,0,1,.08.44,1.18,1.18,0,0,1-.36.81l-8.94,8.59a1.14,1.14,0,0,1-.83.32,1.08,1.08,0,0,1-.43-.1c-.16-.08-.2-.05-.27-.12a5.83,5.83,0,0,0-1.29-1,.55.55,0,0,1-.17-.51,1.88,1.88,0,0,1,.2-.8L129.74,141a1,1,0,0,1,.82-.52A2.12,2.12,0,0,1,131.81,140.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.26,155h0a1.34,1.34,0,0,1-.56-.12l-.12,0a.44.44,0,0,1-.24-.13,6.25,6.25,0,0,0-1.22-.95.79.79,0,0,1-.34-.8A2.06,2.06,0,0,1,124,152l5.47-11.14a1.32,1.32,0,0,1,1.07-.69,2.49,2.49,0,0,1,1.46.38,21.14,21.14,0,0,1,4.14,3.21,1.82,1.82,0,0,1,.47.65,1.28,1.28,0,0,1,.09.53,1.41,1.41,0,0,1-.45,1l-8.95,8.59A1.42,1.42,0,0,1,126.26,155Zm-.5-.77a.49.49,0,0,1,.19.07.89.89,0,0,0,.88-.17l9-8.6A.79.79,0,0,0,136,145a.86.86,0,0,0-.05-.32,1.58,1.58,0,0,0-.32-.39,20.5,20.5,0,0,0-4-3.11h0a1.87,1.87,0,0,0-1-.28.68.68,0,0,0-.56.33l-5.47,11.13a1.52,1.52,0,0,0-.16.66.48.48,0,0,0,0,.24,6.13,6.13,0,0,1,1.34,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,142.17c.65.57,1.35,1.23,1.91,1.78l1.18,1.23a1.16,1.16,0,0,1,0,1.64l-10,9.59a1.16,1.16,0,0,1-1.64,0l-1.18-1.23c-.26-.23-.39-.35-.58-.54s-.1-.71.26-1.24L132.82,142C133.18,141.48,134.14,141.54,135,142.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.23,157.06h0a1.53,1.53,0,0,1-1-.46L125,155.37c-.26-.23-.39-.35-.57-.54a.45.45,0,0,1-.19-.33,1.9,1.9,0,0,1,.41-1.32l7.94-11.36a1.14,1.14,0,0,1,.79-.47,2.44,2.44,0,0,1,1.8.56h0c.8.69,1.55,1.42,1.93,1.8l1.19,1.23a1.49,1.49,0,0,1,.41,1.06,1.41,1.41,0,0,1-.45,1l-10,9.6A1.48,1.48,0,0,1,127.23,157.06ZM133.61,142h-.15a.49.49,0,0,0-.37.2l-7.94,11.35a1.51,1.51,0,0,0-.31.83l.56.51,1.22,1.27a.89.89,0,0,0,.59.26.8.8,0,0,0,.59-.23l10-9.6A.79.79,0,0,0,138,146a.84.84,0,0,0-.23-.6l-1.18-1.23c-.37-.36-1.11-1.07-1.89-1.75A1.94,1.94,0,0,0,133.61,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36,137.85a22.38,22.38,0,0,1,2.59,0c.85.06,1.71.16,2.56.29s1.62.89,1.45,1.5l-3.15,12c-.17.62-.55,1.08-.84,1s-.54-.07-.81-.09a5.61,5.61,0,0,0-.82,0c-.3,0-.63-.48-.73-1.09l-1.84-12.27C117.67,138.52,118.38,137.93,119.36,137.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.05,152.94l-.16,0-.3,0-.46,0h-.34a1.19,1.19,0,0,0-.38,0c-.61.06-1-.65-1.12-1.36l-1.84-12.27a1.21,1.21,0,0,1,.26-.93,2.34,2.34,0,0,1,1.62-.77,15.46,15.46,0,0,1,1.92,0l.7,0c.78,0,1.6.14,2.61.29a2.38,2.38,0,0,1,1.56,1,1.22,1.22,0,0,1,.15.94l-3.14,12C122.94,152.35,122.53,152.94,122.05,152.94Zm-.92-.75.53.05.35,0c.1,0,.35-.26.49-.76l3.14-12a.53.53,0,0,0-.08-.43,1.72,1.72,0,0,0-1.11-.67c-1-.15-1.78-.24-2.52-.28l-.7,0a14,14,0,0,0-1.83,0h0a1.69,1.69,0,0,0-1.17.52.56.56,0,0,0-.13.43l1.84,12.27a1.29,1.29,0,0,0,.39.82,1.67,1.67,0,0,1,.5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68,137.15a21.44,21.44,0,0,1,2.65.4l1.3.29c.43.12.86.27,1.28.41,1,.3,1.52,1.14,1.26,1.72l-5.52,12.7c-.26.58-.66,1-.92.89l-.34-.12-.36-.07a3.48,3.48,0,0,0-.72-.11c-.26,0-.49-.53-.5-1.18l0-13.84C120.84,137.61,121.67,137.05,122.68,137.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.79,153.89l-.13,0-.38-.13a1.72,1.72,0,0,1-.32-.06,2.92,2.92,0,0,0-.39-.07,1.75,1.75,0,0,1-.32,0c-.44,0-.75-.65-.76-1.48l0-13.86a1.15,1.15,0,0,1,.42-.88,2.27,2.27,0,0,1,1.76-.52h0l.44,0a15.78,15.78,0,0,1,2.24.35l1.3.3,1,.32.26.09a2.27,2.27,0,0,1,1.42,1.16,1.17,1.17,0,0,1,0,1L124,152.8C123.69,153.37,123.25,153.89,122.79,153.89Zm-.34-16.42a1.61,1.61,0,0,0-1.06.35.59.59,0,0,0-.21.41l0,13.85a1.17,1.17,0,0,0,.24.86l.24,0a2,2,0,0,1,.52.09l.3.06.4.13a1.86,1.86,0,0,0,.52-.71l5.51-12.7a.58.58,0,0,0,0-.47,1.67,1.67,0,0,0-1-.81l-.27-.09c-.33-.11-.66-.22-1-.31l-1.3-.3a16.12,16.12,0,0,0-2.16-.33l-.44-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.41,142.46c.68-.53,1.4-1,2.13-1.49a25.12,25.12,0,0,1,2.29-1.22c.91-.39,1.83-.2,2,.4l4.21,11.67c.21.6.16,1.2-.11,1.31s-.47.26-.72.37l-.66.46c-.21.21-.76,0-1.21-.47l-8.51-9C106.42,144,106.66,143.1,107.41,142.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,154.38a2,2,0,0,1-1.23-.66l-8.52-9a1.14,1.14,0,0,1-.31-.89,2.39,2.39,0,0,1,.88-1.59h0c.7-.55,1.45-1.05,2.15-1.51l.56-.32a17.63,17.63,0,0,1,1.78-.93,2.32,2.32,0,0,1,1.82-.08,1.12,1.12,0,0,1,.65.68l4.22,11.66c.24.71.21,1.52-.31,1.72a2.06,2.06,0,0,0-.33.17c-.12.07-.24.14-.37.2l-.6.43A.57.57,0,0,1,116.38,154.38Zm-8.76-11.67a1.72,1.72,0,0,0-.65,1.12.49.49,0,0,0,.13.41l8.52,9a1.31,1.31,0,0,0,.77.45l.67-.49.36-.19a3.48,3.48,0,0,1,.43-.22,1.49,1.49,0,0,0-.08-.9l-4.21-11.66a.54.54,0,0,0-.31-.3,1.69,1.69,0,0,0-1.29.09,18.65,18.65,0,0,0-1.72.89l-.55.31C109,141.69,108.3,142.18,107.62,142.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77,140a17.92,17.92,0,0,1,2.41-1.18,17.13,17.13,0,0,1,2.52-.89c1-.32,1.9.09,2,.7l2.68,13.59c.12.65,0,1.14-.27,1.25a4.23,4.23,0,0,0-.68.24,3.19,3.19,0,0,0-.64.32c-.25.1-.69-.16-1.07-.69l-7.86-11.4C108.51,141.43,108.86,140.48,109.77,140Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,154.36a1.67,1.67,0,0,1-1.22-.83l-7.86-11.41a1.21,1.21,0,0,1-.15-1,2.24,2.24,0,0,1,1.16-1.4,20,20,0,0,1,2.45-1.21,18.35,18.35,0,0,1,2.55-.9,2.25,2.25,0,0,1,1.81.15,1.24,1.24,0,0,1,.61.82l2.68,13.58c.14.78,0,1.43-.45,1.61l-.11,0a2.73,2.73,0,0,0-.55.2,2.93,2.93,0,0,0-.56.26l-.08.05A.66.66,0,0,1,117.68,154.36Zm-2.31-16.22a1.8,1.8,0,0,0-.57.1,18,18,0,0,0-2.49.87,18.84,18.84,0,0,0-2.38,1.18h0a1.63,1.63,0,0,0-.84,1,.58.58,0,0,0,0,.48L117,153.16c.32.45.62.56.69.56l0,0a3.35,3.35,0,0,1,.63-.3,3.08,3.08,0,0,1,.63-.23c.06,0,.19-.33.09-.89l-2.68-13.58a.58.58,0,0,0-.3-.38A1.44,1.44,0,0,0,115.37,138.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,149.91l2.17-2.63a1.17,1.17,0,0,1,1.64-.16L114,155a1.17,1.17,0,0,1,.15,1.64L112,159.28a1.16,1.16,0,0,1-1.63.16l-9.57-7.89A1.17,1.17,0,0,1,100.66,149.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,160a1.47,1.47,0,0,1-.94-.34l-9.56-7.89a1.44,1.44,0,0,1-.53-1,1.49,1.49,0,0,1,.33-1.09l2.17-2.62a1.48,1.48,0,0,1,2.09-.21l9.57,7.89a1.49,1.49,0,0,1,.19,2.09l-2.17,2.63A1.48,1.48,0,0,1,111.11,160Zm-7.38-12.85h-.08a.85.85,0,0,0-.57.3l-2.17,2.63a.84.84,0,0,0-.19.61.82.82,0,0,0,.3.56l9.57,7.9a.83.83,0,0,0,1.17-.12l2.17-2.63a.83.83,0,0,0-.11-1.18l-9.56-7.89A.84.84,0,0,0,103.73,147.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,147.79l2.17-2.63c.64-.72,1.6-1,2-.52l10,9.62c.45.46.69,1,.47,1.19l-2.17,2.63a1.17,1.17,0,0,1-1.64.16l-10.68-8.81A1.17,1.17,0,0,1,101.47,147.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,158.83a1.44,1.44,0,0,1-.93-.34l-10.68-8.81a1.42,1.42,0,0,1-.53-1,1.49,1.49,0,0,1,.33-1.09l2.17-2.62a2.45,2.45,0,0,1,1.66-.88,1.12,1.12,0,0,1,.87.33l10,9.61c.65.67.82,1.3.47,1.66l-2.15,2.6a1.47,1.47,0,0,1-1,.54Zm-7.94-14.1h0a1.79,1.79,0,0,0-1.18.65L101.72,148a.84.84,0,0,0-.19.61.82.82,0,0,0,.3.57L112.51,158a.79.79,0,0,0,.61.18.87.87,0,0,0,.57-.3l2.17-2.63c0-.06-.06-.35-.45-.76l-10-9.61A.51.51,0,0,0,105.09,144.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.11,
    y: 152.51,
    width: 5.74,
    height: 14.72,
    rx: 1.17,
    transform: "translate(-86.23 136.77) rotate(-50.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.67,166.62a1.49,1.49,0,0,1-.94-.34l-9.56-7.89a1.42,1.42,0,0,1-.53-1,1.49,1.49,0,0,1,.33-1.09l2.17-2.62a1.48,1.48,0,0,1,2.09-.21l9.57,7.89a1.49,1.49,0,0,1,.19,2.1l-2.17,2.62a1.47,1.47,0,0,1-1,.54ZM98.3,153.77a.86.86,0,0,0-.66.31l-2.17,2.63a.84.84,0,0,0-.19.61.82.82,0,0,0,.3.57l9.57,7.89a.79.79,0,0,0,.61.18.82.82,0,0,0,.56-.3l2.17-2.63a.84.84,0,0,0-.1-1.18L98.82,154A.8.8,0,0,0,98.3,153.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,154.38l2.17-2.62a1.17,1.17,0,0,1,1.64-.17l10.68,8.82a1.16,1.16,0,0,1,.15,1.63l-2.17,2.63a1.15,1.15,0,0,1-1.63.16L96.18,156A1.17,1.17,0,0,1,96,154.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,165.42a1.44,1.44,0,0,1-.93-.34L96,156.27a1.49,1.49,0,0,1-.2-2.09L98,151.55a1.49,1.49,0,0,1,1-.54,1.46,1.46,0,0,1,1.08.33l10.69,8.81a1.5,1.5,0,0,1,.19,2.1l-2.17,2.63a1.5,1.5,0,0,1-1,.53Zm-11.3-10.83a.84.84,0,0,0,.1,1.18l10.68,8.81a.84.84,0,0,0,.61.19.86.86,0,0,0,.57-.31l2.17-2.63a.84.84,0,0,0-.11-1.17l-10.68-8.82a.79.79,0,0,0-.61-.18.87.87,0,0,0-.57.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.78,163.09,92,160.47a1.16,1.16,0,0,1,1.64-.17l9.56,7.9a1.15,1.15,0,0,1,.15,1.63l-2.17,2.63a1.15,1.15,0,0,1-1.63.16l-9.57-7.89A1.17,1.17,0,0,1,89.78,163.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23,173.21a1.47,1.47,0,0,1-.94-.34L89.73,165a1.49,1.49,0,0,1-.2-2.09h0l2.17-2.63a1.49,1.49,0,0,1,1-.54,1.44,1.44,0,0,1,1.08.33l9.57,7.89a1.48,1.48,0,0,1,.53,1,1.46,1.46,0,0,1-.34,1.09l-2.16,2.63A1.54,1.54,0,0,1,100.23,173.21ZM90,163.3a.84.84,0,0,0,.1,1.18l9.57,7.89a.83.83,0,0,0,1.17-.12l2.17-2.63a.8.8,0,0,0,.19-.61.81.81,0,0,0-.29-.56l-9.57-7.9a.79.79,0,0,0-.61-.18.87.87,0,0,0-.57.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6,161l2.16-2.62a1.17,1.17,0,0,1,1.64-.17L105.08,167a1.16,1.16,0,0,1,.15,1.63l-2.17,2.63a1.15,1.15,0,0,1-1.63.16l-10.69-8.81A1.17,1.17,0,0,1,90.6,161Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.16,172a1.5,1.5,0,0,1-.94-.33l-10.68-8.82a1.48,1.48,0,0,1-.19-2.09l2.16-2.63a1.49,1.49,0,0,1,2.09-.21l10.69,8.82a1.5,1.5,0,0,1,.53,1,1.53,1.53,0,0,1-.34,1.09l-2.17,2.63A1.47,1.47,0,0,1,102.16,172Zm-8.49-13.76a.85.85,0,0,0-.66.3l-2.16,2.63a.77.77,0,0,0-.19.62.81.81,0,0,0,.29.56l10.68,8.81a.84.84,0,0,0,1.18-.12l2.17-2.62a.88.88,0,0,0,.19-.62.82.82,0,0,0-.3-.56l-10.68-8.82A.84.84,0,0,0,93.67,158.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.35,169.68l2.16-2.62a1.17,1.17,0,0,1,1.64-.17l9.56,7.9a1.15,1.15,0,0,1,.15,1.63l-2.16,2.63a1.16,1.16,0,0,1-1.64.16l-9.57-7.89A1.17,1.17,0,0,1,84.35,169.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,179.8a1.47,1.47,0,0,1-.94-.34l-9.56-7.89a1.48,1.48,0,0,1-.19-2.09l2.16-2.63a1.49,1.49,0,0,1,2.09-.21l9.57,7.9a1.48,1.48,0,0,1,.19,2.09L96,179.26A1.54,1.54,0,0,1,94.79,179.8ZM87.42,167a.85.85,0,0,0-.66.3l-2.16,2.63a.77.77,0,0,0-.19.62.81.81,0,0,0,.29.56L94.27,179a.84.84,0,0,0,1.18-.12l2.16-2.62a.84.84,0,0,0-.1-1.18l-9.57-7.9A.84.84,0,0,0,87.42,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.16,167.57l2.16-2.63a1.17,1.17,0,0,1,1.64-.17l10.68,8.82a1.16,1.16,0,0,1,.15,1.63l-2.17,2.63A1.16,1.16,0,0,1,96,178L85.31,169.2A1.15,1.15,0,0,1,85.16,167.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.72,178.6a1.46,1.46,0,0,1-.94-.33L85.1,169.45a1.46,1.46,0,0,1-.53-1,1.45,1.45,0,0,1,.34-1.09l2.16-2.63a1.51,1.51,0,0,1,2.1-.21l10.68,8.82a1.49,1.49,0,0,1,.19,2.09l-2.17,2.63a1.51,1.51,0,0,1-1,.54ZM85.41,167.77a.84.84,0,0,0-.19.62.81.81,0,0,0,.29.56l10.68,8.82a.84.84,0,0,0,.61.18.8.8,0,0,0,.57-.31L99.54,175a.84.84,0,0,0-.11-1.18L88.75,165a.84.84,0,0,0-1.18.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.91,176.28l2.16-2.63a1.17,1.17,0,0,1,1.64-.17l9.57,7.9a1.16,1.16,0,0,1,.14,1.63l-2.16,2.63a1.17,1.17,0,0,1-1.64.17l-9.56-7.9A1.15,1.15,0,0,1,78.91,176.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.35,186.39a1.43,1.43,0,0,1-.93-.33l-9.57-7.9a1.48,1.48,0,0,1-.19-2.09l2.16-2.63a1.49,1.49,0,0,1,1-.54,1.53,1.53,0,0,1,1.09.33l9.56,7.9a1.48,1.48,0,0,1,.19,2.09l-2.16,2.63a1.54,1.54,0,0,1-1,.54ZM82,173.55h-.09a.84.84,0,0,0-.57.31l-2.16,2.62a.84.84,0,0,0,.1,1.18l9.57,7.89a.8.8,0,0,0,.61.19.84.84,0,0,0,.57-.31l2.16-2.62a.84.84,0,0,0-.1-1.18l-9.57-7.9A.82.82,0,0,0,82,173.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.72,174.16l2.17-2.63a1.15,1.15,0,0,1,1.63-.16l10.68,8.81a1.17,1.17,0,0,1,.15,1.64l-2.17,2.62a1.16,1.16,0,0,1-1.63.17l-10.68-8.82A1.15,1.15,0,0,1,79.72,174.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,185.19a1.48,1.48,0,0,1-.94-.33L79.66,176a1.48,1.48,0,0,1-.19-2.09l2.16-2.63a1.52,1.52,0,0,1,1-.53,1.44,1.44,0,0,1,1.09.33l10.68,8.81A1.49,1.49,0,0,1,94.6,182l-2.17,2.63a1.47,1.47,0,0,1-1,.54ZM80,174.36a.84.84,0,0,0,.1,1.18l10.69,8.82a.81.81,0,0,0,.6.18.82.82,0,0,0,.57-.3l2.17-2.63a.84.84,0,0,0-.11-1.18l-10.68-8.81a.81.81,0,0,0-1.17.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.47,182.87l2.17-2.63a1.15,1.15,0,0,1,1.63-.16L86.84,188a1.17,1.17,0,0,1,.15,1.64l-2.17,2.62a1.17,1.17,0,0,1-1.64.17l-9.56-7.9A1.15,1.15,0,0,1,73.47,182.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.91,193a1.47,1.47,0,0,1-.93-.33l-9.57-7.9a1.48,1.48,0,0,1-.19-2.09L75.38,180a1.52,1.52,0,0,1,1-.53,1.44,1.44,0,0,1,1.09.33L87,187.72a1.42,1.42,0,0,1,.53,1,1.47,1.47,0,0,1-.33,1.09l-2.17,2.63A1.5,1.5,0,0,1,83.91,193Zm-10.19-9.91a.84.84,0,0,0,.1,1.18l9.57,7.9a.85.85,0,0,0,1.18-.12l2.16-2.63a.83.83,0,0,0,.2-.62.82.82,0,0,0-.3-.56l-9.57-7.89a.81.81,0,0,0-1.17.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.28,180.75l2.17-2.63a1.15,1.15,0,0,1,1.63-.16l10.68,8.81a1.17,1.17,0,0,1,.15,1.64L86.74,191a1.16,1.16,0,0,1-1.63.17l-10.68-8.82A1.15,1.15,0,0,1,74.28,180.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84,191.79a1.47,1.47,0,0,1-.94-.34l-10.68-8.81a1.49,1.49,0,0,1-.19-2.1h0l2.17-2.62a1.48,1.48,0,0,1,2.09-.21L89,186.52a1.48,1.48,0,0,1,.19,2.09L87,191.24A1.48,1.48,0,0,1,85.84,191.79ZM74.53,181a.83.83,0,0,0,.1,1.17L85.32,191a.83.83,0,0,0,1.17-.12l2.17-2.63a.85.85,0,0,0,.19-.62.81.81,0,0,0-.29-.56l-10.69-8.81a.83.83,0,0,0-1.17.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,189.46l2.17-2.63a1.15,1.15,0,0,1,1.63-.16l9.57,7.89a1.17,1.17,0,0,1,.15,1.64l-2.17,2.62a1.17,1.17,0,0,1-1.64.17l-9.56-7.9A1.15,1.15,0,0,1,68,189.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.47,199.58a1.48,1.48,0,0,1-.93-.34L68,191.34a1.48,1.48,0,0,1-.19-2.09L70,186.62a1.49,1.49,0,0,1,2.09-.2l9.56,7.89a1.49,1.49,0,0,1,.2,2.09L79.63,199A1.51,1.51,0,0,1,78.47,199.58ZM71.1,186.73a.84.84,0,0,0-.65.31l-2.17,2.63a.84.84,0,0,0-.19.61.81.81,0,0,0,.29.56l9.57,7.9a.85.85,0,0,0,1.18-.12L81.3,196a.85.85,0,0,0-.11-1.18l-9.57-7.89A.78.78,0,0,0,71.1,186.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.84,187.34,71,184.71a1.16,1.16,0,0,1,1.63-.16l10.68,8.81a1.16,1.16,0,0,1,.15,1.64l-2.17,2.63a1.16,1.16,0,0,1-1.63.16L69,189A1.17,1.17,0,0,1,68.84,187.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,198.38a1.49,1.49,0,0,1-.94-.34l-10.68-8.81a1.52,1.52,0,0,1-.53-1,1.55,1.55,0,0,1,.34-1.09l2.17-2.62a1.48,1.48,0,0,1,2.09-.21l10.68,8.81a1.49,1.49,0,0,1,.19,2.1l-2.17,2.62a1.47,1.47,0,0,1-1,.54ZM69.09,187.55a.84.84,0,0,0-.19.61.86.86,0,0,0,.29.57l10.69,8.81a.77.77,0,0,0,.6.18.82.82,0,0,0,.57-.3l2.17-2.63a.84.84,0,0,0-.1-1.18L72.43,184.8a.83.83,0,0,0-1.17.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,201.7v-5.34a2.69,2.69,0,0,1,.33-1.41,1.6,1.6,0,0,1,1.22-.18l12.07,4.87A5.09,5.09,0,0,1,78,200c.2.1.33.18.33.21v1.48a1.16,1.16,0,0,1-1.16,1.16H64.75A1.16,1.16,0,0,1,63.59,201.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,203.19H64.75a1.49,1.49,0,0,1-1.48-1.49v-5.34a3,3,0,0,1,.37-1.58l0-.08.08,0a1.87,1.87,0,0,1,1.49-.19l12.07,4.86c.33.14.61.28.81.39s.49.26.49.5v1.48A1.49,1.49,0,0,1,77.15,203.19Zm-13-8a2.54,2.54,0,0,0-.23,1.16v5.34a.84.84,0,0,0,.83.84h12.4a.84.84,0,0,0,.83-.84v-1.32l-.15-.09a7.65,7.65,0,0,0-.74-.35L65,195.08A1.15,1.15,0,0,0,64.15,195.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,198.63v-4l1.67-2c.81-1,1.89-1.47,2.39-1.08l11.22,8.16.91.71,0,0v.08l-.34,0s-.11,0-.17,0l-.2.1a1.13,1.13,0,0,1-.45.09H64a1.13,1.13,0,0,1-.45-.09l-.19-.1a1.3,1.3,0,0,1-.17-.26A3.71,3.71,0,0,1,62.87,198.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,201H64a1.39,1.39,0,0,1-.57-.12,1.3,1.3,0,0,1-.26-.14,1.13,1.13,0,0,1-.26-.35,4.08,4.08,0,0,1-.39-1.8v-4.17l1.75-2.12c.95-1.15,2.18-1.64,2.84-1.13l11.21,8.15.93.73.25.21-.18.22a.41.41,0,0,1-.45.28h-.18v0a1.23,1.23,0,0,1-.25.14A1.43,1.43,0,0,1,77.87,201Zm.74-.4.09.14-.1-.28Zm-15.42-5.95v3.94a3.31,3.31,0,0,0,.31,1.48.55.55,0,0,0,.1.16l.1,0a.71.71,0,0,0,.32.07H77.87a.71.71,0,0,0,.32-.07l.15-.07,0,0-.43-.33-11.22-8.16c-.28-.22-1.16.07-1.95,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,210.24v-3.4a1.16,1.16,0,0,1,1.16-1.17h12.4a1.16,1.16,0,0,1,1.16,1.17v3.4a1.16,1.16,0,0,1-1.16,1.17H64.75A1.16,1.16,0,0,1,63.59,210.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,211.74H64.75a1.49,1.49,0,0,1-1.48-1.5v-3.4a1.49,1.49,0,0,1,1.48-1.5h12.4a1.49,1.49,0,0,1,1.48,1.5v3.4A1.49,1.49,0,0,1,77.15,211.74ZM64.75,206a.83.83,0,0,0-.83.84v3.4a.83.83,0,0,0,.83.84h12.4a.83.83,0,0,0,.83-.84v-3.4a.83.83,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,208.09v-3.4A1.16,1.16,0,0,1,64,203.52H77.87A1.16,1.16,0,0,1,79,204.69v3.4a1.16,1.16,0,0,1-1.16,1.17H64A1.16,1.16,0,0,1,62.87,208.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,209.59H64a1.49,1.49,0,0,1-1.48-1.5v-3.4A1.49,1.49,0,0,1,64,203.2H77.87a1.48,1.48,0,0,1,1.48,1.49v3.4A1.49,1.49,0,0,1,77.87,209.59ZM64,203.85a.84.84,0,0,0-.83.84v3.4a.85.85,0,0,0,.83.85H77.87a.84.84,0,0,0,.83-.85v-3.4a.83.83,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,218.79v-3.41a1.16,1.16,0,0,1,1.16-1.16h12.4a1.16,1.16,0,0,1,1.16,1.16v3.41A1.17,1.17,0,0,1,77.15,220H64.75A1.17,1.17,0,0,1,63.59,218.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,220.28H64.75a1.49,1.49,0,0,1-1.48-1.49v-3.41a1.49,1.49,0,0,1,1.48-1.49h12.4a1.49,1.49,0,0,1,1.48,1.49v3.41A1.49,1.49,0,0,1,77.15,220.28Zm-12.4-5.74a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84h12.4a.84.84,0,0,0,.83-.84v-3.41a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,216.64v-3.41A1.16,1.16,0,0,1,64,212.07H77.87A1.16,1.16,0,0,1,79,213.23v3.41a1.17,1.17,0,0,1-1.16,1.17H64A1.17,1.17,0,0,1,62.87,216.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,218.13H64a1.49,1.49,0,0,1-1.48-1.49v-3.41A1.49,1.49,0,0,1,64,211.74H77.87a1.49,1.49,0,0,1,1.48,1.49v3.41A1.49,1.49,0,0,1,77.87,218.13ZM64,212.39a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84H77.87a.84.84,0,0,0,.83-.84v-3.41a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,227.33v-3.4a1.16,1.16,0,0,1,1.16-1.17h12.4a1.16,1.16,0,0,1,1.16,1.17v3.4a1.16,1.16,0,0,1-1.16,1.17H64.75A1.16,1.16,0,0,1,63.59,227.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,228.83H64.75a1.49,1.49,0,0,1-1.48-1.5v-3.4a1.49,1.49,0,0,1,1.48-1.49h12.4a1.49,1.49,0,0,1,1.48,1.49v3.4A1.49,1.49,0,0,1,77.15,228.83Zm-12.4-5.74a.83.83,0,0,0-.83.84v3.4a.84.84,0,0,0,.83.85h12.4a.84.84,0,0,0,.83-.85v-3.4a.83.83,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,225.18v-3.4A1.16,1.16,0,0,1,64,220.61H77.87A1.16,1.16,0,0,1,79,221.78v3.4a1.16,1.16,0,0,1-1.16,1.17H64A1.16,1.16,0,0,1,62.87,225.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,226.68H64a1.49,1.49,0,0,1-1.48-1.5v-3.4A1.49,1.49,0,0,1,64,220.29H77.87a1.49,1.49,0,0,1,1.48,1.49v3.4A1.49,1.49,0,0,1,77.87,226.68ZM64,220.94a.84.84,0,0,0-.83.84v3.4A.85.85,0,0,0,64,226H77.87a.84.84,0,0,0,.83-.85v-3.4a.83.83,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,235.88v-3.41a1.16,1.16,0,0,1,1.16-1.16h12.4a1.16,1.16,0,0,1,1.16,1.16v3.41a1.16,1.16,0,0,1-1.16,1.17H64.75A1.16,1.16,0,0,1,63.59,235.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,237.37H64.75a1.49,1.49,0,0,1-1.48-1.49v-3.41A1.49,1.49,0,0,1,64.75,231h12.4a1.49,1.49,0,0,1,1.48,1.49v3.41A1.49,1.49,0,0,1,77.15,237.37Zm-12.4-5.74a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84h12.4a.84.84,0,0,0,.83-.84v-3.41a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,233.73v-3.41A1.16,1.16,0,0,1,64,229.16H77.87A1.16,1.16,0,0,1,79,230.32v3.41a1.16,1.16,0,0,1-1.16,1.17H64A1.16,1.16,0,0,1,62.87,233.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,235.22H64a1.49,1.49,0,0,1-1.48-1.49v-3.41A1.49,1.49,0,0,1,64,228.83H77.87a1.49,1.49,0,0,1,1.48,1.49v3.41A1.49,1.49,0,0,1,77.87,235.22ZM64,229.48a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84H77.87a.84.84,0,0,0,.83-.84v-3.41a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,244.43V241a1.17,1.17,0,0,1,1.16-1.17h12.4A1.17,1.17,0,0,1,78.31,241v3.41a1.16,1.16,0,0,1-1.16,1.16H64.75A1.16,1.16,0,0,1,63.59,244.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,245.92H64.75a1.49,1.49,0,0,1-1.48-1.49V241a1.49,1.49,0,0,1,1.48-1.49h12.4A1.49,1.49,0,0,1,78.63,241v3.41A1.49,1.49,0,0,1,77.15,245.92Zm-12.4-5.74a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84h12.4a.84.84,0,0,0,.83-.84V241a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,242.28v-3.41A1.17,1.17,0,0,1,64,237.7H77.87A1.17,1.17,0,0,1,79,238.87v3.41a1.16,1.16,0,0,1-1.16,1.16H64A1.16,1.16,0,0,1,62.87,242.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,243.77H64a1.49,1.49,0,0,1-1.48-1.49v-3.41A1.49,1.49,0,0,1,64,237.38H77.87a1.49,1.49,0,0,1,1.48,1.49v3.41A1.49,1.49,0,0,1,77.87,243.77ZM64,238a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84H77.87a.84.84,0,0,0,.83-.84v-3.41a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,253v-3.4a1.16,1.16,0,0,1,1.16-1.17h12.4a1.16,1.16,0,0,1,1.16,1.17V253a1.16,1.16,0,0,1-1.16,1.17H64.75A1.16,1.16,0,0,1,63.59,253Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,254.46H64.75A1.49,1.49,0,0,1,63.27,253v-3.4a1.49,1.49,0,0,1,1.48-1.5h12.4a1.49,1.49,0,0,1,1.48,1.5V253A1.49,1.49,0,0,1,77.15,254.46Zm-12.4-5.74a.84.84,0,0,0-.83.85V253a.83.83,0,0,0,.83.84h12.4A.83.83,0,0,0,78,253v-3.4a.84.84,0,0,0-.83-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,250.82v-3.4A1.16,1.16,0,0,1,64,246.25H77.87A1.16,1.16,0,0,1,79,247.42v3.4A1.16,1.16,0,0,1,77.87,252H64A1.16,1.16,0,0,1,62.87,250.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,252.31H64a1.49,1.49,0,0,1-1.48-1.49v-3.4a1.49,1.49,0,0,1,1.48-1.5H77.87a1.49,1.49,0,0,1,1.48,1.5v3.4A1.49,1.49,0,0,1,77.87,252.31ZM64,246.57a.85.85,0,0,0-.83.85v3.4a.84.84,0,0,0,.83.84H77.87a.83.83,0,0,0,.83-.84v-3.4a.84.84,0,0,0-.83-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,261.52v-3.41A1.16,1.16,0,0,1,64.75,257h12.4a1.16,1.16,0,0,1,1.16,1.16v3.41a1.17,1.17,0,0,1-1.16,1.17H64.75A1.17,1.17,0,0,1,63.59,261.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,263H64.75a1.49,1.49,0,0,1-1.48-1.49v-3.41a1.49,1.49,0,0,1,1.48-1.49h12.4a1.49,1.49,0,0,1,1.48,1.49v3.41A1.49,1.49,0,0,1,77.15,263Zm-12.4-5.74a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84h12.4a.84.84,0,0,0,.83-.84v-3.41a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,259.37V256A1.16,1.16,0,0,1,64,254.8H77.87A1.16,1.16,0,0,1,79,256v3.41a1.17,1.17,0,0,1-1.16,1.17H64A1.17,1.17,0,0,1,62.87,259.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,260.86H64a1.49,1.49,0,0,1-1.48-1.49V256A1.49,1.49,0,0,1,64,254.47H77.87A1.49,1.49,0,0,1,79.35,256v3.41A1.49,1.49,0,0,1,77.87,260.86ZM64,255.12a.84.84,0,0,0-.83.84v3.41a.84.84,0,0,0,.83.84H77.87a.84.84,0,0,0,.83-.84V256a.84.84,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,270.06v-3.4a1.16,1.16,0,0,1,1.16-1.17h12.4a1.16,1.16,0,0,1,1.16,1.17v3.4a1.16,1.16,0,0,1-1.16,1.17H64.75A1.16,1.16,0,0,1,63.59,270.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,271.56H64.75a1.49,1.49,0,0,1-1.48-1.5v-3.4a1.49,1.49,0,0,1,1.48-1.49h12.4a1.49,1.49,0,0,1,1.48,1.49v3.4A1.49,1.49,0,0,1,77.15,271.56Zm-12.4-5.74a.83.83,0,0,0-.83.84v3.4a.84.84,0,0,0,.83.85h12.4a.84.84,0,0,0,.83-.85v-3.4a.83.83,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,267.91v-3.4A1.16,1.16,0,0,1,64,263.34H77.87A1.16,1.16,0,0,1,79,264.51v3.4a1.16,1.16,0,0,1-1.16,1.17H64A1.16,1.16,0,0,1,62.87,267.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,269.41H64a1.49,1.49,0,0,1-1.48-1.5v-3.4A1.49,1.49,0,0,1,64,263H77.87a1.49,1.49,0,0,1,1.48,1.49v3.4A1.49,1.49,0,0,1,77.87,269.41ZM64,263.67a.84.84,0,0,0-.83.84v3.4a.85.85,0,0,0,.83.85H77.87a.84.84,0,0,0,.83-.85v-3.4a.83.83,0,0,0-.83-.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.85,279.68a27.79,27.79,0,0,1-.26-4.48A1.16,1.16,0,0,1,64.75,274h12.4a1.16,1.16,0,0,1,1.16,1.16c0,.54,0,1.27,0,1.44a4.24,4.24,0,0,0,.08.88c0,.16-.08.33-.28.49a1.71,1.71,0,0,1-.74.36L65.3,281.13a1,1,0,0,1-.92-.31A2.13,2.13,0,0,1,63.85,279.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.12,281.47a1.39,1.39,0,0,1-1-.41,2.37,2.37,0,0,1-.63-1.33,27,27,0,0,1-.26-4.3v-.22a1.49,1.49,0,0,1,1.48-1.5h12.4a1.49,1.49,0,0,1,1.48,1.49v.41c0,.35,0,.87,0,1v.19a3.64,3.64,0,0,0,.07.68.84.84,0,0,1-.39.81,2,2,0,0,1-.88.42l-12.09,2.76Zm-.37-7.11a.84.84,0,0,0-.83.84v.23a26.6,26.6,0,0,0,.25,4.19h0a1.68,1.68,0,0,0,.43,1,.71.71,0,0,0,.61.22l12.1-2.76a1.4,1.4,0,0,0,.6-.29.48.48,0,0,0,.17-.19,4,4,0,0,1-.08-.78v-.13c0-.11,0-.47,0-1.05v-.4a.84.84,0,0,0-.83-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,276.52v-3.47A1.16,1.16,0,0,1,64,271.89H77.87A1.16,1.16,0,0,1,79,273.05v3.35c0,.3-.48.59-1.12.65l-13.8,1.15C63.48,278.26,62.91,277.51,62.87,276.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,278.53a1.19,1.19,0,0,1-.79-.32,2.35,2.35,0,0,1-.7-1.68h0v-3.46a1.49,1.49,0,0,1,1.48-1.5H77.87a1.49,1.49,0,0,1,1.48,1.49v3.35a.62.62,0,0,1-.16.44,1.92,1.92,0,0,1-1.26.54l-13.8,1.14Zm-.84-2a1.73,1.73,0,0,0,.48,1.21.52.52,0,0,0,.4.16l13.81-1.15a1.23,1.23,0,0,0,.82-.32v-3.35a.84.84,0,0,0-.83-.85H64a.84.84,0,0,0-.83.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.06,291.06c-.56-.62-1-1.32-1.54-2s-.91-1.42-1.31-2.16-.28-1.78.31-2l11.38-4.94c.59-.25,1.19-.22,1.32.08s.3.5.45.75.33.48.54.69,0,.82-.41,1.27l-8.75,8.79C70.6,292,69.7,291.78,69.06,291.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.41,292.09h0a2.24,2.24,0,0,1-1.56-.81,18.35,18.35,0,0,1-1.18-1.49c-.12-.18-.25-.35-.38-.52-.43-.66-.91-1.42-1.33-2.21a2.3,2.3,0,0,1-.18-1.77,1.18,1.18,0,0,1,.65-.71l11.37-4.94c.79-.33,1.54-.22,1.75.25.06.11.14.24.23.38l.2.34a1.65,1.65,0,0,1,.22.29c.09.11.17.23.27.33.41.43.1,1.21-.41,1.73l-8.75,8.79A1.2,1.2,0,0,1,70.41,292.09Zm8.23-12a1.53,1.53,0,0,0-.62.14l-11.37,4.94a.53.53,0,0,0-.29.34,1.6,1.6,0,0,0,.15,1.24c.4.76.87,1.5,1.28,2.13l.38.52c.36.48.72,1,1.13,1.44h0a1.6,1.6,0,0,0,1.1.59.51.51,0,0,0,.41-.15l8.76-8.79a1.08,1.08,0,0,0,.4-.82,2.81,2.81,0,0,1-.33-.41,2.92,2.92,0,0,0-.21-.28l-.24-.38-.26-.44S78.8,280.1,78.64,280.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.55,288.9a22,22,0,0,1-1.28-2.27l-.56-1.18-.46-1.22c-.36-.94,0-1.86.58-2l13.35-3.66c.62-.16,1.16-.06,1.28.21l.13.37.18.36a4.7,4.7,0,0,0,.39.69c.14.26-.09.75-.61,1.15l-11,8.34C68,290.05,67.07,289.75,66.55,288.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,290.16l-.27,0a2.22,2.22,0,0,1-1.44-1.06l-.09-.16a18.58,18.58,0,0,1-1.2-2.15l-.56-1.17L64,284.34a2.22,2.22,0,0,1,0-1.79,1.2,1.2,0,0,1,.77-.65l13.35-3.66c.78-.2,1.46-.05,1.66.38l.14.41a2.35,2.35,0,0,1,.16.32,2.93,2.93,0,0,0,.23.43c0,.08.11.16.15.24.23.44,0,1.06-.69,1.56l-11.06,8.35A1.14,1.14,0,0,1,68,290.16ZM78.76,278.8a2.11,2.11,0,0,0-.5.07l-13.35,3.66a.64.64,0,0,0-.36.32,1.58,1.58,0,0,0,0,1.26l.46,1.22.55,1.16a20.08,20.08,0,0,0,1.16,2.08l.1.16a1.57,1.57,0,0,0,1,.76.57.57,0,0,0,.47-.08l11.06-8.34c.42-.33.54-.66.51-.74l-.13-.2a3.78,3.78,0,0,1-.28-.53c0-.09-.09-.2-.15-.31l-.16-.43A1.06,1.06,0,0,0,78.76,278.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.53,297.93c-.8-.28-1.6-.55-2.38-.89a23.73,23.73,0,0,1-2.25-1.14c-.83-.5-1.2-1.33-.82-1.87l7-10.24c.36-.5.9-.81,1.17-.64a8.2,8.2,0,0,0,.78.4l.82.31c.31.07.46.65.32,1.27l-2.71,12.1C81.33,297.86,80.46,298.18,79.53,297.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.16,298.34a2.55,2.55,0,0,1-.72-.1h0c-.82-.28-1.62-.56-2.39-.89l-.65-.3a14.49,14.49,0,0,1-1.65-.87,2.26,2.26,0,0,1-1.09-1.38,1.16,1.16,0,0,1,.18-1l7-10.23c.42-.59,1.12-1.05,1.61-.73a1.83,1.83,0,0,0,.39.21,2.64,2.64,0,0,1,.38.18,2.85,2.85,0,0,0,.36.13l.41.16a.61.61,0,0,1,.37.29,1.9,1.9,0,0,1,.15,1.35l-2.71,12.11a1.22,1.22,0,0,1-.57.76A2,2,0,0,1,80.16,298.34Zm-.54-.72a1.73,1.73,0,0,0,1.25-.1.62.62,0,0,0,.27-.35l2.72-12.11a1.12,1.12,0,0,0-.09-.89l-.43-.15-.43-.17c-.14-.08-.25-.12-.35-.17a1.88,1.88,0,0,1-.5-.27s-.42.16-.71.57l-7,10.23a.58.58,0,0,0-.08.45,1.68,1.68,0,0,0,.8,1,13.33,13.33,0,0,0,1.59.83l.64.3C78,297.07,78.82,297.34,79.62,297.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,297.41l-1.17-.57L74,296.17a22,22,0,0,1-2.14-1.48c-.8-.6-1-1.56-.57-2l9.34-10.22c.45-.48,1-.66,1.2-.5a4.33,4.33,0,0,0,.66.46l.33.21.36.16c.26.15.31.69.09,1.3L78.3,297C78.09,297.63,77.14,297.86,76.24,297.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.19,298a2.41,2.41,0,0,1-1.09-.27l-1.17-.57-1.14-.68A17.92,17.92,0,0,1,71.66,295a2.2,2.2,0,0,1-1-1.55,1.22,1.22,0,0,1,.3-1l9.34-10.22c.56-.59,1.2-.82,1.61-.55l.22.16a1.93,1.93,0,0,0,.41.27l.37.24a2.44,2.44,0,0,1,.33.14c.43.26.52.94.25,1.7l-4.92,12.95a1.26,1.26,0,0,1-.73.7A2,2,0,0,1,77.19,298Zm4.37-15.75a1.3,1.3,0,0,0-.74.46L71.48,292.9a.55.55,0,0,0-.13.47,1.53,1.53,0,0,0,.66,1.05,20,20,0,0,0,2.1,1.47l1.13.67,1.15.56a1.56,1.56,0,0,0,1.25.12.58.58,0,0,0,.36-.32L82.92,284c.18-.51.11-.85,0-.9l-.32-.14-.39-.24a2.86,2.86,0,0,1-.48-.32l-.19-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.17,298.92H86.76c-.54,0-1.46-.55-1.39-1.19l.45-12.39c.07-.65.19-1.12.94-1.13h3.41a1.15,1.15,0,0,1,1.16,1.15v12.4A1.16,1.16,0,0,1,90.17,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.73,299.25a2,2,0,0,1-1.34-.65,1.15,1.15,0,0,1-.35-.9l.46-12.37c0-.52.15-1.43,1.26-1.45h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4a1.49,1.49,0,0,1-1.49,1.49H86.73Zm0-14.72c-.43,0-.54.16-.61.84l-.46,12.37a.53.53,0,0,0,.18.42,1.47,1.47,0,0,0,.88.44h3.42a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,299.64H85.75l-.65,0-1.3-.08c-1-.13-1.68-.77-1.56-1.39l2.44-13.64c.12-.62.46-1.1.74-1H86a1,1,0,0,0,.28,0H88a1.16,1.16,0,0,1,1.16,1.16v13.85A1.15,1.15,0,0,1,88,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,300l-2.94-.05-1.3-.07a2.4,2.4,0,0,1-1.64-.87,1.2,1.2,0,0,1-.22-.92l2.44-13.62a1.93,1.93,0,0,1,.66-1.21.6.6,0,0,1,.47-.1l.56,0h2a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,88,300Zm-2.6-16.2c-.1,0-.32.28-.42.79l-2.44,13.62a.51.51,0,0,0,.11.42,1.7,1.7,0,0,0,1.17.6l2.48.12H88a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83H86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,98.71,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71,299.25h-3.4a1.5,1.5,0,0,1-1.5-1.49v-12.4a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,98.71,299.25Zm-3.4-14.72a.84.84,0,0,0-.85.83v12.4a.85.85,0,0,0,.85.84h3.4a.84.84,0,0,0,.84-.84v-12.4a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.56,299.64h-3.4A1.15,1.15,0,0,1,92,298.49V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,96.56,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.56,300h-3.4a1.49,1.49,0,0,1-1.5-1.48V284.64a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v13.85A1.49,1.49,0,0,1,96.56,300Zm-3.4-16.16a.83.83,0,0,0-.84.83v13.85a.83.83,0,0,0,.84.83h3.4a.83.83,0,0,0,.84-.83V284.64a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26,298.92h-3.41a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.16,1.16,0,0,1,1.17,1.15v12.4A1.17,1.17,0,0,1,107.26,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,107.26,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,299.64H101.7a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.17,1.17,0,0,1,1.17,1.16v13.85A1.16,1.16,0,0,1,105.11,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,300H101.7a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,105.11,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,115.8,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,299.25h-3.4a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v12.4A1.5,1.5,0,0,1,115.8,299.25Zm-3.4-14.72a.83.83,0,0,0-.84.83v12.4a.84.84,0,0,0,.84.84h3.4a.85.85,0,0,0,.85-.84v-12.4a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,113.65,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,300h-3.4a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v13.85A1.49,1.49,0,0,1,113.65,300Zm-3.4-16.16a.83.83,0,0,0-.84.83v13.85a.83.83,0,0,0,.84.83h3.4a.84.84,0,0,0,.85-.83V284.64a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,298.92h-3.41a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.16,1.16,0,0,1,1.17,1.15v12.4A1.17,1.17,0,0,1,124.35,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,124.35,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,299.64h-3.41a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,122.2,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,122.2,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,298.92h-3.41a1.17,1.17,0,0,1-1.17-1.16v-12.4a1.16,1.16,0,0,1,1.17-1.15h3.41a1.15,1.15,0,0,1,1.16,1.15v12.4A1.16,1.16,0,0,1,132.9,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,132.9,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75,299.64h-3.41a1.16,1.16,0,0,1-1.17-1.15V284.64a1.17,1.17,0,0,1,1.17-1.16h3.41a1.16,1.16,0,0,1,1.16,1.16v13.85A1.15,1.15,0,0,1,130.75,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,130.75,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,298.92H138a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,141.44,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,299.25H138a1.5,1.5,0,0,1-1.5-1.49v-12.4a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,141.44,299.25ZM138,284.53a.84.84,0,0,0-.85.83v12.4a.85.85,0,0,0,.85.84h3.4a.84.84,0,0,0,.84-.84v-12.4a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.29,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,139.29,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.29,300h-3.4a1.49,1.49,0,0,1-1.5-1.48V284.64a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,139.29,300Zm-3.4-16.16a.84.84,0,0,0-.85.83v13.85a.84.84,0,0,0,.85.83h3.4a.83.83,0,0,0,.84-.83V284.64a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,298.92h-3.41a1.17,1.17,0,0,1-1.17-1.16v-12.4a1.16,1.16,0,0,1,1.17-1.15H150a1.15,1.15,0,0,1,1.16,1.15v12.4A1.16,1.16,0,0,1,150,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48H150a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,150,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84H150a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.84,299.64h-3.41a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.17,1.17,0,0,1,1.17,1.16v13.85A1.16,1.16,0,0,1,147.84,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.84,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,147.84,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.53,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,158.53,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.53,299.25h-3.4a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v12.4A1.5,1.5,0,0,1,158.53,299.25Zm-3.4-14.72a.83.83,0,0,0-.84.83v12.4a.84.84,0,0,0,.84.84h3.4a.85.85,0,0,0,.85-.84v-12.4a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38,299.64H153a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,156.38,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38,300H153a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v13.85A1.49,1.49,0,0,1,156.38,300ZM153,283.81a.83.83,0,0,0-.84.83v13.85a.83.83,0,0,0,.84.83h3.4a.84.84,0,0,0,.85-.83V284.64a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,298.92h-3.41a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.16,1.16,0,0,1,1.17,1.15v12.4A1.17,1.17,0,0,1,167.08,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,167.08,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,299.64h-3.41a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.17,1.17,0,0,1,1.17,1.16v13.85A1.16,1.16,0,0,1,164.93,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,164.93,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63,298.92h-3.41a1.17,1.17,0,0,1-1.17-1.16v-12.4a1.16,1.16,0,0,1,1.17-1.15h3.41a1.15,1.15,0,0,1,1.16,1.15v12.4A1.16,1.16,0,0,1,175.63,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.63,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,175.63,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.48,299.64h-3.41a1.16,1.16,0,0,1-1.17-1.15V284.64a1.17,1.17,0,0,1,1.17-1.16h3.41a1.16,1.16,0,0,1,1.16,1.16v13.85A1.15,1.15,0,0,1,173.48,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.48,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,173.48,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,184.17,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17,299.25h-3.4a1.5,1.5,0,0,1-1.5-1.49v-12.4a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,184.17,299.25Zm-3.4-14.72a.84.84,0,0,0-.85.83v12.4a.85.85,0,0,0,.85.84h3.4a.84.84,0,0,0,.84-.84v-12.4a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16H182a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,182,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,300h-3.4a1.49,1.49,0,0,1-1.5-1.48V284.64a1.49,1.49,0,0,1,1.5-1.48H182a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,182,300Zm-3.4-16.16a.84.84,0,0,0-.85.83v13.85a.84.84,0,0,0,.85.83H182a.83.83,0,0,0,.84-.83V284.64a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.72,298.92h-3.41a1.17,1.17,0,0,1-1.17-1.16v-12.4a1.16,1.16,0,0,1,1.17-1.15h3.41a1.15,1.15,0,0,1,1.16,1.15v12.4A1.16,1.16,0,0,1,192.72,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.72,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,192.72,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.57,299.64h-3.41a1.16,1.16,0,0,1-1.17-1.15V284.64a1.17,1.17,0,0,1,1.17-1.16h3.41a1.16,1.16,0,0,1,1.16,1.16v13.85A1.15,1.15,0,0,1,190.57,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.57,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,190.57,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,201.26,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.26,299.25h-3.4a1.5,1.5,0,0,1-1.5-1.49v-12.4a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v12.4A1.5,1.5,0,0,1,201.26,299.25Zm-3.4-14.72a.83.83,0,0,0-.84.83v12.4a.84.84,0,0,0,.84.84h3.4a.84.84,0,0,0,.84-.84v-12.4a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.11,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,199.11,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.11,300h-3.4a1.49,1.49,0,0,1-1.5-1.48V284.64a1.49,1.49,0,0,1,1.5-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v13.85A1.49,1.49,0,0,1,199.11,300Zm-3.4-16.16a.83.83,0,0,0-.84.83v13.85a.83.83,0,0,0,.84.83h3.4a.84.84,0,0,0,.85-.83V284.64a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,298.92H206.4a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.16,1.16,0,0,1,1.17,1.15v12.4A1.17,1.17,0,0,1,209.81,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,299.25H206.4a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,209.81,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,299.64h-3.41a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.17,1.17,0,0,1,1.17,1.16v13.85A1.16,1.16,0,0,1,207.66,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.66,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,207.66,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35,298.92H215a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,218.35,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35,299.25H215a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v12.4A1.5,1.5,0,0,1,218.35,299.25ZM215,284.53a.83.83,0,0,0-.84.83v12.4a.84.84,0,0,0,.84.84h3.4a.85.85,0,0,0,.85-.84v-12.4a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,216.2,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,300h-3.4a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v13.85A1.49,1.49,0,0,1,216.2,300Zm-3.4-16.16a.83.83,0,0,0-.84.83v13.85a.83.83,0,0,0,.84.83h3.4a.84.84,0,0,0,.85-.83V284.64a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,298.92h-3.41a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,226.9,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,226.9,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.75,299.64h-3.41a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,224.75,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.75,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,224.75,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.45,298.92H232a1.17,1.17,0,0,1-1.17-1.16v-12.4a1.16,1.16,0,0,1,1.17-1.15h3.41a1.15,1.15,0,0,1,1.16,1.15v12.4A1.16,1.16,0,0,1,235.45,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.45,299.25H232a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,235.45,299.25ZM232,284.53a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,299.64h-3.41a1.16,1.16,0,0,1-1.17-1.15V284.64a1.17,1.17,0,0,1,1.17-1.16h3.41a1.16,1.16,0,0,1,1.16,1.16v13.85A1.15,1.15,0,0,1,233.3,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,233.3,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15H244a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,244,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,299.25h-3.4a1.5,1.5,0,0,1-1.5-1.49v-12.4a1.49,1.49,0,0,1,1.5-1.48H244a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,244,299.25Zm-3.4-14.72a.84.84,0,0,0-.85.83v12.4a.85.85,0,0,0,.85.84H244a.84.84,0,0,0,.84-.84v-12.4a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,241.84,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,300h-3.4a1.49,1.49,0,0,1-1.5-1.48V284.64a1.49,1.49,0,0,1,1.5-1.48h3.4a1.48,1.48,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,241.84,300Zm-3.4-16.16a.84.84,0,0,0-.85.83v13.85a.84.84,0,0,0,.85.83h3.4a.83.83,0,0,0,.84-.83V284.64a.83.83,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,298.92h-3.41a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.16,1.16,0,0,1,1.17,1.15v12.4A1.17,1.17,0,0,1,252.54,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,252.54,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,299.64H247a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.17,1.17,0,0,1,1.17,1.16v13.85A1.16,1.16,0,0,1,250.39,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,300H247a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,250.39,300ZM247,283.81a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.08,298.92h-3.4a1.16,1.16,0,0,1-1.17-1.16v-12.4a1.15,1.15,0,0,1,1.17-1.15h3.4a1.15,1.15,0,0,1,1.17,1.15v12.4A1.16,1.16,0,0,1,261.08,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.08,299.25h-3.4a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v12.4A1.5,1.5,0,0,1,261.08,299.25Zm-3.4-14.72a.83.83,0,0,0-.84.83v12.4a.84.84,0,0,0,.84.84h3.4a.85.85,0,0,0,.85-.84v-12.4a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,299.64h-3.4a1.15,1.15,0,0,1-1.17-1.15V284.64a1.16,1.16,0,0,1,1.17-1.16h3.4a1.16,1.16,0,0,1,1.17,1.16v13.85A1.15,1.15,0,0,1,258.93,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,300h-3.4a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.4a1.49,1.49,0,0,1,1.5,1.48v13.85A1.49,1.49,0,0,1,258.93,300Zm-3.4-16.16a.83.83,0,0,0-.84.83v13.85a.83.83,0,0,0,.84.83h3.4a.84.84,0,0,0,.85-.83V284.64a.84.84,0,0,0-.85-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,298.92h-3.41a1.16,1.16,0,0,1-1.16-1.16v-12.4a1.15,1.15,0,0,1,1.16-1.15h3.41a1.16,1.16,0,0,1,1.17,1.15v12.4A1.17,1.17,0,0,1,269.63,298.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,299.25h-3.41a1.49,1.49,0,0,1-1.49-1.49v-12.4a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v12.4A1.49,1.49,0,0,1,269.63,299.25Zm-3.41-14.72a.84.84,0,0,0-.84.83v12.4a.85.85,0,0,0,.84.84h3.41a.85.85,0,0,0,.84-.84v-12.4a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.48,299.64h-3.41a1.15,1.15,0,0,1-1.16-1.15V284.64a1.16,1.16,0,0,1,1.16-1.16h3.41a1.17,1.17,0,0,1,1.17,1.16v13.85A1.16,1.16,0,0,1,267.48,299.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.48,300h-3.41a1.49,1.49,0,0,1-1.49-1.48V284.64a1.49,1.49,0,0,1,1.49-1.48h3.41a1.49,1.49,0,0,1,1.49,1.48v13.85A1.49,1.49,0,0,1,267.48,300Zm-3.41-16.16a.84.84,0,0,0-.84.83v13.85a.84.84,0,0,0,.84.83h3.41a.84.84,0,0,0,.84-.83V284.64a.84.84,0,0,0-.84-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.89,159.16h16.39a4.36,4.36,0,0,1,4.36,4.36v5.68a0,0,0,0,1,0,0h-25.1a0,0,0,0,1,0,0v-5.68A4.36,4.36,0,0,1,136.89,159.16Z",
    transform: "translate(-73.6 150.68) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,177.31l-4.37-4.37a4.87,4.87,0,0,1,0-6.87L147,154.48a4.86,4.86,0,0,1,6.87,0l4.37,4.37Zm10.65-23.25a3.79,3.79,0,0,0-2.72,1.13L136.1,166.78a3.84,3.84,0,0,0,0,5.45l3.66,3.67,17.05-17.05-3.67-3.66A3.83,3.83,0,0,0,150.41,154.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.48 186.41 173.55 190.34 151.89 168.3 162 158.19 177.48 186.41",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,191.05,151.19,168.3l10.92-10.93,16,29.13ZM152.59,168.3l21,21.33,3.31-3.31-15-27.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.09 195.8 172.02 191.87 149.98 170.21 139.87 180.32 168.09 195.8",
    style: {
      fill: "#42B5C4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,196.42l-29.12-16L150,169.51l22.75,22.36ZM140.7,180.2l27.3,15,3.31-3.31-21.33-21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.55,
    y: 151.03,
    width: 5.84,
    height: 35.08,
    transform: "translate(162.97 -56.32) rotate(45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,183.74l-4.84-4.84,25.51-25.51,4.84,4.84Zm-3.42-4.84,3.42,3.42,24.09-24.09-3.42-3.42Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.41fff4f52da7c24c440a264fde48f182.svg";
export { ForwardRef as ReactComponent };